export const PopUpMessage = {
    thank_you_initial_info:"Thank you for taking the self assessment and filling the health record!",
    choose_plan_message:'Please choose "Evaluation Plan" and make the payment to enable fixing an appointment.',
    plan_button_text:"Take Membership Plan",
    thank_you_niyama_msg:"Thank you for signing up to",
    take_assesment_msg:'You can do a free self-assessment by answering a few questions. Please select "Assessment" from the menu',
    current_health_info_msg:'Please share your current health record for our Care Team to understand better before fixing an appointment.',
    select_health_info_text:'Please select "Health Record" from the menu, to enter the mandatory fields.',
    thank_you_msg:"Thank you for choosing Ziloy!",
    consultation_details_msg:" Please find your consultation details.",
    thank_you_apointment_req_msg:"Thank you for requesting appointment!",
    join_consultation_eva_msg:"Doctor is allocated kindly join the consultation at ",
    join_consultation_other_msg:"Appointment is confirmed, kindly join the consultation at ",
    join_consultation__msg_1:"Your appointment is confirmed with",
    join_consultation__msg_2:" Please remember to join the consultation at",
    please_wait_msg:"Please wait for our Care Admin to confirm the same.",
    my_consultations: "My Consultations",
    my_consultations_subtitle: "Pending appointments for today",
    my_patient: "My Clients",
    my_patient_subtitle: "Missed prescriptions & case notes for this month",
    hi: "Hi",
    THANK_YOU_FOR_CHOOSING: "Thank you for choosing",
    PLEASE_BOOK_APPOINTMENT: "Please book an appointment with our care team for a detailed",
    SMALL_CONSULTATION: "consultation",
    SMALL_EVALUATION: "evaluation",
    SESSION: "session",
    PLEASE_UPGRADE_RENEW: "Please upgrade or renew your plan to enable fixing appointment.",
    COMPLETED_EVALUATION: "You have completed your evaluation plan.",
    CHOOSE_SUBSCRIPTION_PLAN: "Please choose your suggested membership plan.",
    RENEW_YOUR_PLAN: "Please renew your plan to enable fixing appointment.",
    YOUR_DASHBOARD: "Your",
    HAS_EXPIRED: "has expired.",


}

export const CONSTANTS ={
// Patient side constants
    SELF_ASSESSMENT: "Self Assessment",
    TAKE_QUESTIONAIRES:"Take the questionnaire to know your mental condition",
    SKIP_LATER:"Skip, I’ll do this later.",
    ASSESSMENT_TEXT:"Along with your regular reflection, assessing your current risk for common conditions can be an important part of caring for your mental health.",
    TAKE_ASSESSMENT: "Take Assessment",
    VIEW_DETAILS: "View Details",
    FILL_DETAILS: "Fill Details",
    DEPRESSION: "Depression",
    ANXIETY: "Anxiety",
    STRESS: "Stress",
    DEPRESSION_ANXIETY: "Depression / Anxiety",
    DEPRESSION_AND_ANXIETY: "Depression & Anxiety",
    ADOLESCENT: "Adolescent",
    SEE_MY_SCORE: "See my score",
    SELF_ASSESSMENT_SENIOR_ADULT: "Self assessment for senior adult",
    SELECT_ASSESSMENT_LANDING_DESCRIPTION_1: "You can take these assessments every 15 days, from your last assessed date.",
    LAST_ASSESSED_ON: "Last assessed on",
    TAKE_ASSESSMENT_FROM:"Next assessment on",
    BACK_TO_PREVIOUS_PAGE: "< Back To Previous Page",
    BACK:"Back",
    QUESTION: "Question",
    HEALTH_INFORMATION: "Health Information",
    MEDICAL_DOCUMENT: "Medical Document",
    BASIC_INFORMATION: "Basic Information",
    MY_APPOINTMENTS: "My Appointments",
    VIDEO_CONSULTATION: "Video Consultation",
    PHI_CARD_DESCRIPTION: "Click on Health Information to enter your health related data.",
    COMPLETED: "% Completed",
    YOU_HAVE_COMPLETED: "You have completed",
    ASSESSMENT_S: "assessment(s)",
    ASSESSMENTS: "Assessments",
    NIYAMA_CARE_DESCRIPTION_1: "Get yourself evaluated by our Clinician",
    NIYAMA_CARE_DESCRIPTION_2: "Your plan has expired. Take a membership plan to proceed",
    NIYAMA_CARE: "Ziloy Care",
    VIEW_PLAN: "View Plan",
    NIYAMA_CARE_DESCRIPTION_3_PART2: " | Valid upto",
    NIYAMA_CARE_DESCRIPTION_3_PART1: "You are subscribed to",
    TAKE_SUBSCRIPTION_PLAN: "Take Membership Plan",
    ACTIVATE_PLAN:"Activate Plan",
    YOUR: "Your",
    NOT_SUBSCRIBED_CENTER_TEXT_1: "has expired.",
    NOT_SUBSCRIBED_CENTER_TEXT_2: "You have not subscribed yet!",
    NOT_SUBSCRIBED_CENTER_TEXT_3: "Only one appointment can be scheduled in accordance with your current membership plan.",
    NO_APPONITMENTS: "No appointments booked yet!",
    COMMON_WRAPPER_CARD_CONTENT_APPOINTMENT: "Please subscribe to a membership plan and book appointments.",
    LAST_CONSULTATION: "Last consultation done with ",
    NO_CONSULTATION: "No consultations done yet!",
    TASKS_FOR_YOU: "TASKS FOR YOU",
    TASKS_FOR_YOU_PASCAL_CASE: "Tasks For You",
    COMPLETE_SELF_ASSESSMENT: "Complete Self Assessment",
    FILL_UP_HEALTH_INFORMATION: "Fill up Health Information",
    GET_THE_RIGHT_PLAN: "Get the right plan",
    BASIC_HEALTH_INFORMATION: "(Basic health information is not yet filled.)",
    SELF_ASSESSMENT_NOT_TAKEN: "(Self Assessment is not yet taken.)",
    HAVENT_SUBSCRIBED: "(You haven't subscribed to any plan yet.)",
    BOOK_YOUR_APPOINTMENT: "Book your Appointment",
    JOIN_NOW: "Join now",
    CLICK_JOIN_TO_START: "Click 'join' to start the consultation with",
    APPOINTMENT_DETAILS: "Appointment Details",
    TIME: "Time",
    SUBSCRIPTION_PLAN: "Membership Plan",
    PREVIEWING: "Previewing...",
    PREVIEW_VIDEO: "Preview Video",
    SAY_SOMETHING: "Say Something...",
    CHECK_AUDIO: "Check Audio",
    CANCEL: "Cancel",
    TEST_CONNECTION_JOIN: "Test Connection and Join",
    NO_ASSESSMENT_DONE: "No assessments done yet!",
    PLEASE_TAKE_SELF_ASSESSMENT: "Please take self-assessment to unlock this section.",
    TAKE_EVALUATION_PLAN:"Take Evaluation Plan",
    BOOK_APPOINTMENT_CARD_DESCRIPTION:"Your appointment is confirmed & scheduled with ",
    BOOK_APPOINTMENT_CARD_DESCRIPTION_1: "Your appointment will be confirmed soon.",
    APPOINTMENTS: "Appointments",
    CONSULTATION: "Consultations",
    SELF_ASSESSMENT_ADOLESCENT: "Self Assessment for Adolescents",
    NO_SELF_ASSESSMENT: "No Self-Assessment option is enabled for your profile.",
    SCHEDULE_TEXT:"Select your preferred time slot and doctor to book appointment",
    SCHEDULE_APPOINTMENT: "Schedule Appointment",
    SCHEDULE_AN_APPOINTMENT: "Schedule an Appointment",
    UPCOMING_APPOINTMENTS: "Upcoming Appointments",
    PAST_APPOINTMENTS: "Past Consultations",
    BOOK_NOW: "Book Now",
    UPCOMING: "Upcoming",
    PAST: "Past",
    EVALUATION_REPORT: "Psychological Feedback Report",
    PRESCRIPTION: "Prescription",
    ZERO_ENCOUNTER: "Zero Encounter",
    APPOINTMENT_STATUS:"Appointment Status",
    MODE: "Mode:",
    SEARCH_BY_DOCTOR: "Search by doctor",
    SELECT_YOUR_DATE: "SELECT YOUR DATE",
    SELECT_YOUR_TIME_SLOT: "SELECT YOUR TIME",
    SELECTED_DATE: "Selected Date",
    CHOOSE_ANOTHER_PROFILE: "Choose another profile",
    DISCARD_ASSESSMENT: "Discard assessment",
    SUBSCRIPTION_TITLE: "Choose a recommended plan to begin your treatment journey with",
    CONFIRMATION_TEXT_CONTENT_1: "You already have an active membership plan, by continuing with the new plan, you can't enjoy the benefits of the old plan.",
    CONFIRMATION_TEXT_CONTENT_2: "Would you like to proceed?",
    APPOINTMENT_CENTER_TEXT: "You can schedule a call after a care team is assigned to you. You shall receive an email/mobile notification once the care team is assigned.",
    SUBSCRIPTION_EVAL_MESSAGE: "we do a detailed evaluation adhering to the international standards of assessment. This is to help us arrive at an accurate diagnosis of your problem and suggest an appropriate treatment plan for you to effectively manage the condition.",
    EXPIRED: "Expired",
    COMPLETED_TEXT: "Completed",
    EXPIRED_ON: "Expired on",
    EXPIRES_ON: "Expires on",
    AVAILED_ON_NEW: "Availed on",
    ALL_PATIENTS_SEGMENT: "All Clients",
    MY_PATIENTS_SEGMENT: "My Clients",
    ACTIVE: "Active",
    ACTIVE_CAPS: "ACTIVE",
    USE_COUPON: "Use Coupon?",
    UPDATE_EXP_DATE :"Update Expiry Date",
    TOTAL_PRICE: "Total Price",
    DISCOUNT: " Discount(-)",
    DISCOUNT_PERCENT:"Discount(%)",
    START_DATE:"Start Date",
    TOTAL: "Total",
    PAY: "Pay",
    COUPON_CODE: "Coupon Code:",
    COUPON_NAME: "Coupon Name",
    COUPON_CODE_1: "Coupon Code",
    PAYMENT_SUMMARY:"Payment Summary",
    CONTINUE: "Continue",
    CONTINUE_ASGUEST: "Continue As Guest",
START_YOUR_MENTAL_HEL_JNRY:"Start your mental health journey with us.",
    RETRY_PAYMENT: "Retry Payment",
    APPLY: "Apply",
    REMOVE: "Remove",
    ENTER_COUPON_CODE: "Enter Coupon Code",
    ACTIVATE_COUPON_CODE : "Please click on Apply to activate coupon",
    ERROR_IN_PAYMENT:"Error in payment status retrival",
    PAYMENT_TERMINATE: "Error in payment terminate",
    TRANSACTION_NUMBER: "Transaction Number:",
    AMOUNT:"Amount",
    MEMBERSHIP_PLAN: "Membership Plan",
    DATE_AND_TIME: "Date & Time",
    PAYMENT_MODE:"Payment Mode",
    STATUS_DESCRIPTION: "Status Description",
    MY_ORDERS_ALL:"All",
    ALL_DOCUMENTS:"All Documents",
    UPLOADED_BY_YOU:"Uploaded By You",
    REQUESTED_BY_DOCTOR:"Requested By Doctor",
    MY_ORDERS_PAID:"Paid",
    MY_ORDERS_FAILED:"Failed",
    MY_ORDERS_PENDING:"Pending",
    PAYMENT_ABORTED:"Aborted",
    DATE: "Date",
    TRANSACTION_ID:"Transaction ID",
    ORDER_ID:"Order ID",
    PAYMENT_STATUS:"Status",
    PAYMENT_LAST_UPDATED:"Last Updated On",
    PAYMENT_RECEIPT:"Receipt",
    BASIC_INFO: "Basic Info",
    CHANGE_PASSWORD: "Change Password",
    SETTINGS : "Settings",
    CANNOT_UNDO_ACTION: "You can’t undo this action",
    HEALTH_RECORD_DELETED: "All your health records and profile information will be deleted.",
    DO_YOU_WANT_TO_DELETE: "Do you want to delete this account?",
    DELETE_ACCOUNT: "Delete Account",
    ACCOUNT_RECOVERED_SUCCESSFULLY: "Account recovered successfully!",
    ACCOUNT_DELETED: "Account Deleted",
    RETAIN_YOUR_ACCOUNT_CONTENT_1: "We will retain your account information with us for next 30 days.",
    RETAIN_YOUR_ACCOUNT_CONTENT_2: "You can recover your account on or before",
    DELETED: "Deleted!",
    NAME:"Name",
    NAME_CAPITAL: "NAME",
    ID : "ID",
    CLINICIAN: "CLINICIAN",
    EMAIL_ID: "Email ID",
    MOBILE_START:"Mobile Number *",
    MOBILE_NUMBER: "Mobile Number",
    TIME_ZONE: "Time Zone",
    LANGUAGE : "Language",
    PLEASE_SELECT_LANGUAGE: "Please select language",
    UPDATE: "Update",
    PLEASE_SELECT_TIME_ZONE: "Please select time zone",
    SEND_OTP: "SEND OTP",
    ENABLE_WATSAPP_SETTINGS: "Enable WhatsApp Notifications",
    BOOK_APPOINTMENT: "Book Appointment",
    PSYCHIATRIST: "Psychiatrist",
    AGE: "Age",
    COLON: ":",
    DOB_CAPS: "DOB",
    GENDER: "Gender",
    CREATE_NEW_ACCOUNT: "Create New Account",
    RELATION_WITH_CARE_RECEIVER: "Relationship with Care Receiver",
    MOBILE: "Mobile",
    ACCOUNT_HOLDER_FIRST_NAME: "Account Holder First Name",
    ACCOUNT_HOLDER_LAST_NAME: "Account Holder Last Name",
    CARE_RECEIVER_NAME: "Care Receiver Name",
    CARE_RECEIVER_FIRST_NAME : "Care Receiver First Name",
    CARE_RECEIVER_LAST_NAME : "Care Receiver Last Name",
    MALE: "Male",
    FEMALE: "Female",
    OTHERS: "Others",
    RECEIVER_NAME: "Name of Care Receiver",
    DOB: "Date Of Birth ",
    DATE_FORMAT: "DD-MM-YYYY",
    DATE_FOOTER_MESSAGE: "Select or Enter the date to get updated",
    HI: "Hi",
    REGISTRATING_WITH_US: " By registering with us,",
    YOU_AGREE: "you agree to ZILOY",
    ON_BEHALF_OF_CARE_RECEIVER: "on behalf of Dependant,",
    TERMS_AND_CONDITION: "Terms ",
    PRIVACY_POLICY: "Privacy Policy.",
    AGREE_TO: "I agree to",
    AGREE: "Agree",
    CONSENT_FORM_TITLE: "Parental Consent for Child/Adolescent Mental Health Assessment and Treatment.",
    CONSENT_FORM_CONTENT_1: "Mental health assessment and treatment methods [such as Psychotherapy and Pharmacotherapy] are most effective when a trusting relationship exists between the child/adolescent and the clinician [Psychotherapist/Psychiatrist]. It is hence necessary for children/adolescents to establish a “zone of privacy” with their psychotherapists/psychiatrists allowing them to discuss personal matters freely.",
    CONSENT_FORM_CONTENT_2: "Therefore, while we will provide you with general information about the assessment and treatment of your child/adolescent during Parental Check in sessions, it may not be possible to share everything that your child/adolescent has disclosed to us as we are dictated by the medical code of conduct and privacy, akin to any client-healthcare provider relationship.",
    CONSENT_FORM_CONTENT_3: "However, if the child/adolescent is at serious risk of harming him/herself or another, or if there are any other issues of medico-legal implications, we will definitely inform you.",
    CONSENT_FORM_CONTENT_4: "In case of disagreement among parents themselves and/or disagreement between parents and the psychotherapist/psychiatrist regarding the treatment of the child/adolescent, and despite earnest efforts to address these disagreements, if either parent decides to terminate treatment, we shall request the option of having a few closing sessions with the child/adolescent to end treatment appropriately without adversely impacting the child/adolescent’s mental health.",
    CONSENT_FORM_CONTENT_5: "You will also kindly understand and agree that our role is strictly limited to providing psychotherapy/psychiatric sessions for the benefit of your child/adolescent mental health and wellness care. Please treat anything said in Parental check-in sessions as strictly confidential. You agree that you will not involve us in any legal dispute, especially those concerning parental separation/divorce proceedings, child custody or visitation arrangements. We are ethically bound not to give our opinion about the suitability of either parent's custody or visitation rights. You will not ask us to testify in court, either in person or by affidavit.",
    CONSENT_FORM_CONTENT_6: "If you have any questions about the information contained in this contract, please discuss them with us prior to signing below. Clicking yes indicates that you have a) obtained the assent of your child/adolescent implying his approval for his assessment and treatment and b) you hereby give your consent to your child/adolescent's mental health assessment and treatment and have thereby entered into a legally binding agreement with the terms set forth in this contract.",
    ACCEPT: "Accept",
    READ_PRIVACY_POLICY: "Please read Privacy Policy, Terms and Conditions",
    VALIDATION_MESSAGE: "This field cannot be empty",
    CREATING_NEW_ACCOUNT_DOT: "Creating New Account...",
    ADD_NEW_MEMBER: "Add New Member",
    CHOOSE_PROFILE: "Choose Profile",
    ADD_DEPENDANT: "Add dependent to your account",
    ACCOUNT_SETTINGS: "Account Settings",
    CONTINUE_MODAL_TITLE: "Please Accept our updated policies to continue",
    PARENT_GUARDIAN_NAME: "Parent/Guardian Name",
    ACCEPT_TERMS_OF_USE: "Accept Terms of Use",
    ACCEPT_PRIVACY_POLICY: "Accept Privacy Policy",
    YEARS: "Years",
    YEARS_GAP: " Years, ",
    OPEN_WITH: "Open with",
    NIYAMA_APP: "Ziloy App",
    WEB_BROWESER: "Web Browser",
    SUBMITTING: "Submitting...",
    SUBMIT: "Submit",
    LEVEL: "Level",
    SCORE: "Score",
    YOUR_SCORE_INDICATES: "Your Score Indicates",
    OF: "of",
    FOR: "for",
    OUT_OF_18: "out of 18",
    BOTTOM_TITLE_PART_1: "Your scores indicate",
    ANXIETY_AND: "Anxiety and",
    DEPRESSION_SYMPTOMS: "Depression symptoms!",
    IGD: "IGD",
    ADHD: "ADHD and",
    OCD: "OCD symptoms!",
    SELF_ASSESSMENT_RESULT: "Your result for Self Assessment",
    BOTTOM_INFO_1: "*These are self-reported scores, and these responses have to be validated and confirmed by a clinician upon a thorough evaluation.",
    PAYMENT_INVOICE:"Invoice",
    GUEST_USER_LANDING_DESCRIPTION: "Kindly login or sign up to know your assessment result.",
    NO_DATA_CONTENT_MONTH: "No Assessment taken yet!",
    NO_DATA_CONTENT_YEAR: "You have not taken any assessment for the current year.",
    NO_DATA_CONTENT_PAST_YEAR: "You have not taken any assessment for the past years.",
    CONSULTATION_FOR_UPCOMING: "You don't have an upcoming appointment.",
    CONSULTATION_FOR_CURRENT_MONTH: "You have not taken any appointment.",
    NO_CONSULTATION_FOR_UPCOMING: "No upcoming appointment.",
    NO_CONSULTATION_FOR_PAST: "No past appointment.",
    SUBSCRIBED_SUCCESSFULLY: "subscribed successfully!",
    PLAN_SUBSCRIBED_SUCCESSFULLY: "Plan subscribed successfully!",
    SCHEDULE_AN_APPOINTMENT:"Schedule an Appointment",
    ERROR_DURATION_SUBCRIPTION: "Error during subscription!",
    HI_ALERT_MSG:"Kindly click on the Dashboard option from the Menu to proceed further.",
    HI_ALERT_MSG_UPLOAD_DOC:"To upload any medical document.",
    IHI_FORMAT_MSG:"File must be jpeg/jpg, png, or pdf.",
    IHI_TOOLTIP:"The information furnished in these sections is protected and shall be accessible only to the Care Team.",
    IHI_VALIDATION_MSG:"This field is required",
    TELL_US:"Tell us what’s wrong",
    IHI_ON_FINISH_ERR_MSGG:"Fill the duration of problem",
    PREVIOUS: "Previous",
    NEXT: "Next",
    VALID_UPTO: "Valid Upto: ",
    ENDED_ON: "Expired On: ",
    AVAILED_ON_STAT: "Availed On: ",
    SHOW_DOCS:"Showing all the documents.",
    UPLOAD_OTHER_DOCS:"Upload Other Documents",
    DOC_REQ_DOCS:"Doctor Requested Documents",
    ADD_NEW_DOC:"Add New Document",
    MY_PROFILE_HEADING_MESSAGE:"Review and update your details here",
    ADD_NEW_MEMBER_SUB_1: "Let’s get your account set up",
    ADD_NEW_MEMBER_OPTION_2:"To make sure we get this right, we need some basic details.",
    ADD_NEW_MEMBER_SUB_2: "To make sure we get this right, we need some basic details and guardian’s consent.",
    SWITCH_ACCOUNT: "Switch Account",
    CHOOSE_A_PROFILE: "Choose a profile or create a new one",
    DEPENDANT_DETAILS: "Dependant's Details",
    
    ENTER_THE_DETAILS: "Enter the details of dependant",



    CALL_YOUR_NAVIGATOR: "Call your care navigator to reschedule",
    CHAT_WITH_NAVIGATOR: "Send an email to our Care support",
    SCHEDULE_CONSULTATION: "Schedule a consultation",
    CARE_PLANS: "Care Plans",
    LIBRARY: "Library",
    QUICK_LINKS: "QUICK LINKS",
    START_FILLING_HI: "Start filling the health information for clinician to understand you better.",
    COMPLETE_HEALTH_INFO: "Complete the health information for clinician to understand you better.",
    COMPLETED_WITHOUT_PERCENT: "Completed",
    VIEW_CONSULTATION: "View Consultations",
    NO_CONSULTATION_DONE: "No consultation done yet!",
    TASKS_FOR_YOU_NEW: "TASKS FOR YOU",
    SEE_ALL: "See all",
    CARE_PLAN_B2B: "Care Plan",
    WITH: "with",
    CURRENT_PLAN: "CURRENT PLAN",
    JOIN_NOW_CAPS: "JOIN NOW",
    NEXT_STEPS:"NEXT STEPS",


    HEALTH_INFO_PERCENT_FILLED: "All your health information completed successfully.",
    HEALTH_INFO_PERCENT_MSG1: "Fill up your health information for us to understand you better.",
    HEALTH_INFO_PERCENT_MSG2: "It will take just a few minutes to complete this section",
    HEALTH_RECORD_CAPS: "HEALTH RECORD",
    CAREPLAN_CAPS: "CARE PLAN",
    SELF_ASSESSMENT_CAPS: "SELF ASSESSMENT",
    SEE_ALL_CAPS: "See all",
    PAST_CONSULTATIONS: "PAST CONSULTATIONS",
    REQUESTED_MEDICAL_TEST: "REQUESTED MEDICAL TESTS",
    MEDICATION_CAPS: "MEDICATIONS",
    REPORT_ISSUE_DASHBOARD: "Report Issue",
    REQUESTED_BY: "Requested by",
    ONGOING: "ONGOING",
    CHOOSE_PLAN_CONTENT: "Get a personalised care plan to start your journey to mental wellbeing.",
    DETAILED_EVALUATION: "Take a detailed evaluation by our Ziloy expert to know your mental health.",
    GET_EVALUATED: "Get Evaluated Now",
    EXPIRED_MSG: "Renew your existing care plan or choose a new plan as recommended.",
    RENEW_CARE_PLAN: "Renew Care Plan",
    CHOOSE_CARE_PLAN_DASHBOARD: "Choose Care Plan",
    PAYMENT_REMINDER: "Payment Reminder!",
    PLAN_INCLUDES: "Plan includes:",
    PATIENT_UID: "Patient UID",
    PATIENT_NAME: "Patient Name",
    mobile_number:"mobile number",
    name:"name",
    email:"email",
    TIMER:179000,
    // TIMER:5000,
    PLAN: "Plan",
    VIEW_CONSULTATIONS: "View consultations",
    INSTRUCTION_HISTORY: "Instruction history",
    INSTRUCTION_HISTORY_CAPS: "Instruction History",
    NO_INSTRUCTION_HISTORY: "No filled instructions!",
    CHOOSE_CARE_PLAN: "Choose Care Plan",
    SKIP: "Skip",
    DOT: ".",
    PAYMENT: "Payment",
    SELECTED_CARE_PLAN: "Your selected care plan",
    OPTION: "Option",
    APPOINTMENT: "Appointment",
    START_CONSULTATION: "Start consultation",
    CLICK_START_TO_BEGIN: "Click start to begin the consultation with",
    SEARCH_BY_PATIENT: "Search by client...",
    SEARCH_BY_PATIENT_NEW: "Search by client",
    PROFILES: "Profiles",
    TICKET_ID: "Ticket ID",
    TICKET_TYPE: "Ticket Type",
    TICKET_RAISED_ON: "Ticket Raised On (UTC)",
    CARE_TEAM: "Care Team",
    STATUS: "Status",
    RESOLVE: "Resolve",
    CALL_DETAILS: "Call Details",
    PATIENT_CONTACT: "Patient Contact",
    DOCTOR: "Doctor",
    PATIENT: "Patient",
    CALL: "Call",
    REFRESH: "Refresh", 
    ACCOUNT_HOLDER_DETAILS: "Account Holder Details",
    EMAIL: "Email",
    PATIENT_DETAILS: "Patient Details",
    CONTACT_INFO: "Contact Info",
    AGE_GROUP: "Age Group",
    CONSULTATION_RATING: "Consultation Rating",
    CALL_RATING: "Video Call",
    APP_RATING: "App",
    CONSULTATION_COMMENTS: "Consultation: ",
    PATIENT_VIDEO_CALL_FEEDBACK: "Patient Video Call Feedback",
    ACCOUNT_TYPE: "Account Type",
    CALL_STATUS: "Call Status",
    GET_LIVE_STATUS: "Get Live Status",
    DOCTOR_JOIN_STATUS: "Doctor Join Status",
    PATIENT_JOIN_STATUS: "Patient Join Status",
    CALL_TIME: "Call Time",
    CONSULTATION_LIST: "Consultation List",
    TICKET_LIST: "Ticket List",
    PATIENT_RECORDS: "Patient Records",
    THIS_MONTH: "This Month",
    THIS_YEAR: "This Year",
    PAST_YEAR: "Past Year",
    ASSESSMENT_HISTORY: "Assessment History",
    CONSULTATION_HISTORY: "Consultation History",
    SCHEDULE_YOUR_APPOINTMENT: "Schedule Your Appointment",
    MY_PROFILE: "My Profile",
    CONSULTATION_DATE: "Consultation Date",
    RESCHEDULE_APPOINTMENT: "Reschedule Appointment",
    CANCEL_APPOINTMENT: "Cancel Appointment",
    VIDEO_CALL: "Video Call",
    DOCUMENT_TYPE: "Document Type",
    DESCRIPTION: "Description",
    ACTION: "Action",
    VIEW: "View",
    EDIT: "Edit",
    DELETE: "Delete",
    UPLOAD: "Upload",
    SUBSCRIBE: "Subscribe",
    RENEW: "Renew",
    UPGRADE: "Upgrade",
    CHOOSE: "Choose",
    CONSENT_FORM: "Consent Form",
    DEPENDANT_CONSENT_FORM: "Dependant :",
    DOB_COLON: "Date Of Birth :",
    TODAY_DATE: "Today’s Date :",
    GUARDIAN_NAME: "Guardian’s Name :",
    TAKE_OUR_SELF_ASSESSMENT: "Take Our Self Assessment",
    SELECT_ASSESSMENT_LANDING_DESCRIPTION: "These are internationally validated questions to assess the symptoms and their degree. However, these are not conclusive diagnostic methods and should be verified by a clinician.",
    ASSESSMENT_LANDING_DESCRIPTION: "These are internationally validated symptom checklists used for the detection of depression and anxiety symptoms. These should take less than 3 minutes to complete.",
    ASSESSMENT_LANDING_DESCRIPTION_ADOLESCENT: "Take a 2-minute quiz to learn if your teen's behaviour is normal, or a sign of a deeper issue.",
    ASSESSMENT_LANDING_DESCRIPTION_STRESS: "Please answer the following questions to know the presence and degree of stress.",
    ASSESSMENT_LANDING_DESCRIPTION_1: "Please answer the questions based on how the child has been feeling in the past 3 months.",
    ASSESSMENT_LANDING_DESCRIPTION_2_PART_1: "Please answer the questions based on how you have been feeling in the past",
    ASSESSMENT_LANDING_DESCRIPTION_2_PART_2: "You can take this test every 15 days.",
    ASSESSMENT_LANDING_DESCRIPTION_STRESS_1: "Please answer the questions based on how you have been feeling in the past 3 months.",
    ASSESSMENT_LANDING_DESCRIPTION_OTHERS_1: "Please answer the questions based on how you have been feeling in the past 2 weeks.",
    ASSESSMENT_LANDING_DESCRIPTION_SENIOR_ADULT_1: "Please answer the questions based on how you have been feeling in the past 1 month.",
    ASSESSMENT_LANDING_DESCRIPTION_INSOMNIA:"Please answer the following questions with reference to the last one month.",
    ASSESSMENT_LANDING_DESCRIPTION_GERIATRIC:"Please answer the following questions with reference to the last one month.",
    ASSESSMENT_LANDING_DESCRIPTION_WOMEN:"Please answer the questions based on how you have been feeling in the recent past.",
    MONTHS: "months",
    MONTH: "month",
    WEEKS: "weeks",
    ASSESSED_ON: "Assessed on",
    SCHEDULE_YOUR_APPOINTMENT: "Schedule Your Appointment",
    SELECT_DATE_TIME_SLOT: "Selected date and time slot",
    SELECT_DOCTOR: "Select Doctor",
    MY_PROFILE: "My Profile",
    MY_ORDERS:"Order History",
    MY_ORDERS_SUCCESS:"Success",
    MY_ORDERS_FAILURE:"Failure",
    CLOSE: "Close",
    BOTTOM_INFO: "Get to know more by having an evaluation call with our Clinician.",
    GO_TO_APPOINTMENTS:"Go to Appointments",
    GO_TO_APPOINTMENTS_NEW:"Go to appointments",
    SELECT_REASON:"Select Reason",
    SELECT_DATE_AND_TIME:"Select Date & Time",
    APPOINTMENT_BOOKED:"Appointment Booked",
    CHOOSE_CARE_PLAN:"Choose Care Plan",
    APPOINTMENT_CONFORMATION: "Appointment confirmation",
    APPOINTMENT_REVIEW_TITLE: "Confirm your appointment with",
    CONFIRM: "Confirm",
    RESCHEDULE_CAPS: "RESCHEDULE",
    CANCEL_CAPS: "CANCEL",
    HELPFUL_TIPS: "Helpful tips for virtual visits",
    JOIN_VIDEO_CALL: "Join a video visit 5 mins before your appointment time.",
    ENSURE_YOUR_FACE: "Ensure your face is visible on camera.",
    CHECK_VIDEO_AUDIO_WRK: "Check your video and audio is working.",
    ALL_CALLS_POINT: "All calls with our care providers are monitored for quality assurance and may be recorded.",
    YOU_CAN_ALSO_fACE: "You can also leave a message using chat if you are facing any issues.",
    HAVE_A_QUES: "Have a question?",
    SIMPLY_SEND_CHAT1: "Simply send us a chat through the ",
    SIMPLY_SEND_CHAT2: " chat. Our care navigator team is always here to help.",
    WANT_TO_SHARE_FEEDBACK: "Want to share your feedback?",
    LEAVE_FEEDBACK: "LEAVE FEEDBACK",
    CHAT_WITH_US:"CHAT WITH US",
    APPOINTMENT_WITH: "Appointment with",
    SCHEDULED_TIME: "Scheduled Time",
    CALL_DURATION: "Call Duration",
    APPOINTMENT_REVIEW: "Appointment Review",
    WRAPPER_HEADER: "Appointments to be Revised",
    SCHEDULE_TIME: "Schedule Time",
    CASESHEET: "Casesheet",
    CONSULT: "Consult",
    PRESCRIBE: "Prescribe",
    TODAY: "Today",
    UPCOMING_APPOINTMENT : "Upcoming Appointment",
    PAST_APPOINTMENT : "Past Appointment",
    CONSULTATION_TO_BE_DONE: "Consultations to be done",
    CONSULTATION_DONE: "Consultations done",
    AVAILABILITY: "Availability",
    DOCTOR_CONTENT: "will be available in the following time slots (local time).",
    NO_SLOTS: "No slots are available for",
    RESCHEDULE_TITLE: "This will create a request for rescheduling an appointment. Our care admin will reach out to you for a new appointment. Do you wish to proceed?",
    CANCEL_TITLE: "This will create a request for cancelling an appointment. Do you wish to proceed?",
    YES: "Yes",
    NO: "No",
    OK: "OK",
    LOGIN_IN: "Login Now",
    PHI_CENTER_TEXT: "You have not filled Health Information details yet!",
    NO_SLOTS_AVAILABLE: "No time slot is available.",
    NOT_SCHEDULED_APPOINTMENT: "You have not scheduled any appointments yet!",
    SUBSCRIPTION_MESSAGE: "Continue with our Mental Wellness Program to maintain your mental health",
    PRIZE_TYPE: "/month",
    PLAN_DETAILS: "Membership benefits includes",
    MY_CONSULTATIONS: "My Consultations",
    TODAYS_APPOINTMENT: "Today's Appointments",
    VIEW_ALL:"View All",
    VIEW_PAST: "View Past",
    VIEW_UPCOMING: "View Upcoming",
    APPOINTMENT_NO_DATA_CONTENT: "No appointments scheduled for today!",
    MY_AVAILABILITY: "My Availability",
    AVAILABILITY_SUB_CONTENT_HEADER: "Provide your available timing for patients to book appointments.",
    AVAILABLE_DAYS: "Available Days",
    AVAILABILITY_SUB_CONTENT_HEADER_1: "Mention your leave days to skip appointments.",
    HOLIDAYS: "Leave Days",
    CLICK_TO_PROCEED: "Click to proceed",
    DOCTOR_AVAILABILITY: "Available days and time slots",
    AVAILABILITY_DOCTOR_POPUP_1: "Enter your planned non-working days",
    AVAILABILITY_DOCTOR_POPUP_2: "Enter your working days in a week",
    ADD_HOLIDAY: "Add Leave Days",
    ADD_AVAILABILITY: "Add Availability",
    OTP_EMAIL: "Enter the OTP sent to your email id",
    OTP_SENT_TO_EMAIL: "Enter the OTP sent to your email",
    OTP_EMAIL_ID: "Enter the OTP sent to your mail ID",
    OTP_NUMBER:"Enter the OTP sent to your mobile number",
    SUBMIT_CAPS: "SUBMIT",
    VERIFYING_OTP: "Verifying Otp...",
    VERIFY_OTP: "Verify OTP",
    MULTI_DOC: "Custom Document",
    CASENOTES: "Casenotes",
    ADD_CASENOTES: "Add Casenotes",
    ADD_PSYCHIATRIC:"Add Psychiatry Feedback Report",
    PST:"PFR",
    PST_RPT:"Psychiatry Feedback Report",
    DOTS: "DOTS",
    MSE: "MSE",
    MSE_FULLFORM:"Mental Status Examination",
    EXPIRY_DATE_TIME:"Expiry Date Time",
    MHE_BLOCK_1: "PRE-MORBID CHECKLIST",
    PRE_MORBID_CHECKLIST_LABEL: "Attention, Persistence, Frustration Tolerance",
    NORMAL_UNIMPAIRED: "Normal/Unimpaired",
    MILDLY_IMPAIRED: "Mildly Impaired",
    MARKEDLY_IMPAIRED: "Markedly Impaired",
    COGNITIVE: "'C'ognitive",
    EXAMINATION_ASEPTIC: "EXAMINATION ('ASEPTIC')",
    MSE_SUB_BLOCK: "'A'ppearance, Behaviour, Motor Activity",
    GOOD: "Good",
    POOR: "Poor",
    NORMAL: "Normal",
    FAIR: "Fair",
    REDUCED: "Reduced",
    OVERFRIENDLY: "Overfriendly",
    ABSENT: "Absent",
    PRESENT: "Present",
    SPEECH: "'S'peech",
    SPEECH_LANGUAGE: "Speech and Language",
    PRESSURED: "Pressured",
    SLOWED: "Slowed",
    JARGON_NEOLOGISMS: "Jargon / Neologisms",
    EMOTION: "'E'motion",
    EUTHYMIC: "Euthymic",
    DEPRESSED: "Depressed",
    ELATED: "Elated",
    ANXIOUS: "Anxious",
    NORMAL_RANGE: "Normal Range",
    STABLE: "Stable",
    CONSTRICTED: "Constricted",
    LABILE: "Labile",
    PERCEPTION: "'P'erception",
    HALLUCINATION: "Hallucinations",
    THOUGHT: "'T'hought",
    FORM_AND_CONTENT: "Form & Content",
    PATIENT_HISTORY: "Patient History",
    ANXIETY_LEVEL: "Anxiety Level",
    DEPRESSION_LEVEL: "Depression Level",
    STRESS_LEVEL: "Stress Level",
    ADD_ICON: "Click the + icon to fill information",
    DSM_SCREENING: "DSM",
    BRIEF_PSYCHOTHERAPEUTIC_INTAKE: "Brief Psychotherapeutic Intake",
    DIAGNOSIS: "Diagnosis",
    GENERAL_CASE_SHEET: "General Case Sheet",
    THERAPHY_PRGORESS : "Therapy Progress Note",
    PSYCHOLOGICAL_FLEXIBILITY_RATING : "Psychological Flexibility Rating",
    PSYCHOTHERAPY_GOAL : "Psychotherapy Goal",
    TREATMENT_PLAN: "Treatment Plan",
    PROTECTIVE_FACTOR: "Protective Factors",
    DOTS_SMALL: "Dots",
    SOS_SMALL: "Sos",
    TRANSCRIPTION: "Transcription",
    ADD_PRESCRIPTION: "Add Prescription",
    ADD_GENERAL_CASE_SHEET:"Add General Case Sheet",
    ADD_DSM_SCREENING: "Add DSM",
    ADD_MSE: "Add MSE",
    ADD_BRIEF_PSY: "Add Brief Psychotherapeutic Intake",
    ADD_THERAPHY_PROGRESS : "Add Therapy Progress Note",
    ADD_DIAGNOSIS: "Add Diagnosis",
    ADD_PROTECTIVE_FACTOR: "Add Protective Factors",
    ADD_DOTS: "Add DOTS",
    ADD_SOS: "Add SOS",
    ADD_TREATMENT_PLAN: "Add Treatment Plan",
    PUBLISH: "Publish",
    TOTAL_CONSULTED: "Total Consulted",
    CONSULTED_DOCTORS: "Care Team",
    CARETEAM_CAPS: "CARE TEAM",
    CONSULTED_CLINICIAN: "Consulted clinicians for ",
    LAST_CONSULTED: "Last Consulted",
    LAST_CONSULTED_ON: "Last consulted on",
    MISSED_PRESCRIPTION: "Missed Prescriptions",
    MISSED_CASENOTES: "Missed Casenotes",
    MISSED_PRESCRIPTION_PUBLISH: "Missed Prescriptions Publish",
    MISSED_EVAL_REPORTS_PUBLISH: "Missed Evaluation Reports Publish",
    MY_PATIENTS: "My Patients",
    PATIENTS: "Patients",
    LAST_CONSULTATION_PATIENT_TABLE: "Last Consultation",
    LAST_cONSULTATION_CAPITAL: "LAST CONSULTATION",
    NEXT_CONSULTATION: "Next Consultation",
    NEXT_cONSULTATION_CAPITAL: "NEXT CONSULTATION",
    PLAN_DETAILS_TABLE: "Plan Details",
    ORGANIZATION:"ORGANIZATION",
    NEXT_APP_TABLE: "NEXT APPOINTMENT",
    CONSULTATION_TABLE: "CONSULTATION",
    SEEN_BY_ME: "Seen by me",
    PLAN_DETAILS_CAPITAL: "PLAN",
    CASESHEET_SUMMARY: "Casesheet Summary",
    ASSESSMENT_TABLE: "Assessment",
    HIGH: "High",
    AVERAGE: "Average",
    LOW: "Low",
    OPENNESS_LOW:"(Narrow field of interests, likes the tried and true) Low",
    OPENNESS_HIGH:"High (Imaginative, curious, open to new ideas)",
    CONSCIE_LOW : "(Impulsive, carefree) Low",
    CONSCIE_HIGH : "High (Responsible, dependable, goal oriented)",
    EXTRA_LOW:"(Quiet, withdrawn, unassertive) Low",
    EXTRA_HIGH:"High (Outgoing, energetic, gregarious)",
    AGREE_LOW:"(Aloof, easily irritated) Low ",
    AGREE_HIGH:"High (Warm, considerate, good natured)",
    NEURO_LOW:"(Moody, tense, lower self-confidence)Low",
    NEURO_HIGH:"High(Stable, confident)",
    HYPERACTIVE: "Hyperactive",
    PERSONALITY_TRAITS_OCEAN: "PERSONALITY TRAITS ('OCEAN')",
    MILD: "Mild",
    SEVERE: "Severe",
    SAD:"Sad",
    HAPPY: "Happy",
    INSIGHT: "'I'nsight",
    STATIC_TITLE_DSM: "Additional screening for Psychiatric symptoms (DSM)",
    QUESTION_TITLE_DSM: "All questions to be answered 'yes' or 'no' with reference to the past 2 weeks.",
    SUBSCRIBE_TO: "Subscribed to",
    ASSESSMENT_SETTINGS: "Assessment Settings",
    SAVE: "Save",
    ASSESSMENT_SCORE: "Assessment Score",
    CHAT_TEXT: ", Welcome to NIYAMA. I am here to help you.",
    BASED_ON_RECENT_ASSESSMENT: "Based on the recent assessment done",
    NO_ASSESSMENT_TAKEN: "No Assessment taken yet!",
    SOS_CAPS: "Symptoms Of Stress",
    APPOINTMENT_CONSULTATION: "Appointment / Consultation",
    HAVE_COMPLETED: "Have completed",
    MEDICINES_PRESCRIBED: "Medicines prescribed on last consultation",
    CASESHEET_EDITED: "Casenotes last edited on ",
    VIEW_CASESHEET: "View Casenotes",
    SECTION_OF_HI_SUMMARY: "Section of HI Summary",
    VIEW_SUMMARY: "View Summary",
    ADD_ANSWER: "Add Answer",
    PSY_QUESTION_TITLE: "There are contrasting statements at either end and numbered 1-10. For each scale, choose where you would place yourself by selecting a number depending on how closely, you feel the statements apply to you. If you feel that both the statements apply equally, or that neither statement applies to you, score 5. This rating will help to understand you better and know which area you would need to work on more.",
    PSY_QUESTION_TITLE1_ADOLESCENT: "Here we have six double-headed arrows, numbered 1-10. For each scale, choose where you would place yourself by selecting a number depending on how closely, you feel the statement applies to you.",
    PSY_QUESTION_TITLE2_ADOLESCENT: "For e.g. If you feel the statement does not apply to you at all select 1 for never, or if it applies to you approximately 50 percent of the times, select 5. This rating will help us to understand you better and know which area you would need to work on more.",
    PSY_QUESTION_FEEDBACK1:"What is your understanding of how counselling or psychotherapy can help to work on the problem? Willingness to work on one's mental health?",
    PSY_QUESTION_FEEDBACK1_ADOLESCENT:"What is maintaining the problem?",
    PSY_QUESTION_FEEDBACK2_ADOLESCENT:"How can psychotherapy help?",
    SPECIFIC_REASON: "Specific Reason if Low?",
    SUITABILITY_RATING: "Suitability Rating",
    COLLABORATION_RATING: "Collaboration Rating",
    TIMEZONE_WARNING_1:"Your preferred Timezone is GMT",
    TIMEZONE_WARNING_2:" and current Timezone is GMT",
    TIMEZONE_WARNING_3:"Do you want to switch your Timezone?",
    PRESCRIPTION_NOT_CREATED : "*Your prescription was not published. Please reach out to our care admin for any queries.",
    PRESCRIPTION_NOT_CREATED_CARE_ADMIN : "*Prescription was changed/not created and not published. Contact doctor.",
    FORGOT_YOUR_PASSWORD: "Forgot Your Password",
    PREVIEW_EVAL_REPORT:"Preview Psychological Feedback Report",
    PREVIEW_PST_REPORT:"Preview Psychiatry Feedback Report",
    USER_TYPE: "User Type",
    YES_I_REQUIRING_CARE: "Yes. I am the one requiring care.",
    NO_CREATING_FOR_SOMEONE: "No. I am doing on behalf of someone else who needs the care.",
    SEND_OTP_SMALL: "Send OTP",
    VERIFY_OTP_SMALL: "Verify OTP",
    OPTIONAL_MESSAGE_LOGIN: "Already have an account? ",
    FORGOT_PASSWORD: "Forgot Password",
    EMAIL_ID_MOBILE_NUMBER: "Email ID / Mobile Number",
    BACK_TO_LOGIN: "Cancel",
    SENDING_OTP_DOT: "Sending Otp...",
    LOGIN_TO_ACCOUNT: "Login to your account",
    SIGNIN_TO_ACCOUNT:"Sign in to your account",
    EMAIL_ID_MOBILE: "Email ID/Mobile",
    GO_TO_ASSESS_HISTORY:"Go to Assessment History",
    TAKE_FREE_EVALUATION_CALL:"Book Your First Appointment",
    GO_TO_DASHBOARD:"Go To Dashboard",
    PASSWORD: "Password",
    PASSWORD_STAR:"Password *",
    FORGOT_PASSWORD_QUESTION: "Forgot Password?",
    LOGGING_IN_DOT: "Logging In...",
    LOGIN_CAPS: "LOGIN",
    LOGIN_WITH_PASSWORD: "Login with password",
    LOGIN_WITH_OTP: "Login with OTP",
    DONT_HAVE_ACCOUNT: "Don't have an account?",
    VERIFYING_DOT: "Verifying...",
    VALIDATION_MOBILE_MESSAGE: "Please enter Email/Mobile number",
    VALIDATION_EMAIL_MESSAGE: "Please enter your Email ID",
    VALIDATION_MOBILENUMBER_MESSAGE: "Please enter a valid mobile no. with country code (eg:+91)",
    OR: "or",
    COUPON_USAGE:"Usage",
    STARTED_WITH_ASSESSMENT: "What brings you to",
    DEPRESSION_ANXIETY_TEENS: "Ziloy for Teens - Adolescent Mental Health Care",
    DEPRESSION_ANXIETY_ADULT: "Assessment and Holistic Treatment (Anxiety/Depression/Insomnia)",
    STRESS_ADULTS: "Preventive Mental Wellness - Stress Management",
    SIGN_UP: "Sign Up",
     SIGNS_UP: "Sign up",
    LOGIN_SMALL: "Login",
    USER_NOT_ALLOWED: "User was not allowed to Login",
    USER_NOT_REGISTERED: "User not Registered with us",
    OTP_SENT_SUCCESSFULLY: "OTP sent successfully!",
    LOGGED_IN_SUCCESSFULLY: "Logged in successfully!",
    LOGGED_OUT_SUCCESSFULLY: "Logged out successfully!",
    LOGIN_ASSESSMENT_INCOMPATIBLE: "The login user type and the self assessment type were incompatible. Prior assessment taken before logging in was not added to your profile.",
    INVALID_OTP: "Invalid OTP. Please re-enter OTP or use Re-send OTP option.",
    EMAIL_VERIFIED_SUCCESSFULLY: "Email Successfully Verified",
    OTP_VERIFIED_SUCCESSFULLY: " OTP Successfully Verified",
    FIELD_REQUIRED: "This field is required",
    INVALID_SELF_ASSESSMENT: "Invalid self-assessment. This self-assessment is not applicable for your profile.",
    YOU_ARE_NOT_ELIGIBLE: "You are not eligible for this self-assessment, your next",
    STRESS_SMALL: "stress",
    ASSESSMENT_ON_SMALL: "assessment on",
    ASSESSMENT_DONE: "Assessment done",
    ASSESSMENT_DONE_CONTENT: "You can now see the assessment result.",
    VIEW_RESULT: "View Result",
    DEPRESSION_ANXIETY_SMALL: "depression/anxiety",
    LOGOUT: "Are you sure you want to logout?",
    LOGOUT_TITLE: "Logout",
    CAPS_LOGOUT: "LOGOUT",
    LOGGING_OUT: "Logging Out...",
    CHAT_TEXT: ", Welcome to ZILOY. I am here to help you.",
    PLEASE_SELECT_DOCTOR: "Please select the doctor.",
    RESEND_OTP_IN: "Resend OTP in",
    RESEND_OTP: "Resend OTP",
    VOICE_OTP: "Get OTP in call",
    DIDNOT_RECEIVE_OTP: "Didn't receive OTP?",
    TROUBLE_RECEIVING_OTP: "Trouble Receiving OTP in SMS?",
    CASESHEET_UPDATE_ERROR_MESSAGE: "Please submit/update the casenotes",
    PLEASE_ENTER_NOTES: "Please enter notes!!",
    NO_DATA_FOUND: "No data found",
    SERVICE_REQUIRED_PLACEHOLDER: "Is this service required for you or someone else?",
    YOUR_EMAIL: "Your Email",
    YOUR_MOBILE: "Your Mobile",
    NO_DATA: "No Data",
    NO_DATA_SEARCH: "No data",
    FILE_FORMAT_ERROR_MESSAGE_1: "File format must be JPEG/PNG/PDF",
    FILE_FORMAT_ERROR_MESSAGE_2: "File must not exceed 5 MB",
    YOU_CAN_UPLOAD: "You can upload only JPG/PNG/PDF format",
    FILE_SIZE: "File size must be smaller than 2MB",
    FILE_SIZE_25: "File must not exceed 25MB size",
    CONFIRMATION: "Confirmation",
    CONTINUE_WITH_ZILOY_WAY: "Continue with ziloy way?",
    YES_PROCEED: "Yes, Proceed",
    DELETE_SURE_MESSAGE: "Are you sure you want to delete it?",
    KINDLY_SELECT_DASHBOARD_OPTION: "Kindly click on the Dashboard option from the Menu to proceed further.",
    DASHBOARD: "Dashboard",
    PRESENTING_MENTAL_HEALTH_PLACEHOLDER: "Explain in your own words - the symptoms, issues bothering you...",
    CONTEXT_OF_PROBLEMS: "Context of Problems/Concerns/Difficulties",
    PHYSICAL_ILLNESS: "Physical Illness (Past/Present)",
    PAST_MENTAL_ILLNESS: "Past Mental Illness",
    EDUCATIONAL_DETAILS: "Education Details",
    OCCUPATIONAL_DETAILS: "Occupational Details",
    EDUCATIONAL_LEVEL: "Educational Level",
    OCCUPATION: "Occupation",
    PRESENTING_COMPLAINT: "Presenting Complaints",
    DETAILS_SAVE_SUCCESSFULLY: "Details saved successfully!",
    UPLOADING: "Uploading...",
    FILE_FORMAT: "(File format: JPEG, PNG, PDF)",
    MAX_FILE_SIZE: "(Max file size: 25 MB)",
    LOADING: "Loading...",
    SELECT: "Select",
    ADD_MEDICATION: "Add Medication",
    ADD_RELATIONSHIP: "Add Relationship",
    PLEASE_TYPE_HERE: "Please type here",
    QUANTITY: "Quantity",
    SINCE: "Since",
    REASON_FOR_RELAPSE: "Reason for relapse",
    WITHDRAWAL_SYMPTOMS: "Withdrawal Symptoms",
    ABSTINENCE: "Abstinence",
    SPECIFY: "Specify",
    RELATIONSHIP: "Relationship",
    DURATION: "Duration",
    FREQUENCY: "Frequency",
    TYPE_HERE: "Type here",
    CONDITION: "Condition",
    PLEASE_MENTION: "Please mention",
    ILLNESS_CONDITION: "Illness/Condition",
    MEDICATION: "Medication",
    DOSAGE: "Dosage",
    STARTING_YEAR: "Starting Year",
    CARE_TEAM_CONTEXT_OF_PROBLEMS: "Context of Problems/Concerns/Difficulties(Care Team)",
    OTHER: "Other",
    EXPLAIN_IN_YOUR_OWN_WORDS: "Explain in your own words - the symptoms, issues bothering you...",
    RECENT_EVENT_IN_PARENTS_LIFE: "Recent Events in Parents Life",
    SUBSTANCE_USE: "Substance Use",
    IF_YES_SPECIFY: "If Yes, Specify",
    KG_M: "kg/m",
    TWO: "2",
    UPLOAD_DOCUMENT: "Upload Document",
    CM: "cm",
    KG: "kg",
    SOMETHING_WENT_WRONG: "Oops! Something went wrong.",
    EXP: "Exp:",
    SELECT_DOMAIN: "Select domain",
    PLEASE_SELECT_ACTIVITY: "Please select a activity type.",
    CLICK_TO_START: "Click to start",
    MY_TICKETS: "My Tickets",
    NO_TICKETS_AVAILABLE: "No Tickets Available",
    DOCTORS_NOT_AVAILABLE: "Doctors not available!!",
    DOCTOR_ASSIGNED: "Doctor assigned successfully!",
    ERROR_MESSAGE_1: "Please select a Doctor or Cancel!",
    ERROR_MESSAGE_2: "Please select date and time!",
    SUCCESSFULLY: "successfully!",
    SCHEDULED_DATE_TIME: "Please schedule with date and time !!",
    TICKET_RESOLVED: "Ticket resolved successfully!",
    TICKET_SNOOZED: "Ticket snoozed successfully!",
    SELECT_DOCTOR_EXCLAMATION: "Please select a Doctor!",
    ERROR_MESSAGE_3: "Once submitted, this appointment will be scheduled to",
    CHOOSE_ONE_OR_MORE: "Choose one or more ticket types to resolve",
    PLEASE_SELECT_TICKET: "Please select a ticket type before proceeding.",
    SEARCH: "Search",
    RESET: "Reset",
    INACTIVE: "Inactive",
    JOINED: "Joined",
    YET_TO_JOIN: "Yet to Join",
    NOT_JOINED: "Not Joined",
    NOT_ELIGIBLE: "Not Eligible",
    ENTER_THE_REGISTERED: "Enter the registered ",
    CHOOSE_OPTION:"Choose any one option to proceed",
    TO_VIEW: "to view the patient details",
    EMAIL_ID_REQUIRED: "Email Id is required",
    NAME_REQUIRED: "Name is required",
    MOBILE_REQUIRED: "Mobile number is required",
    ADD_ON: "+91",
    ENTER_YOUR_EMAIL: "Enter your email id",
    ENTER_YOUR_NAME: "Enter your name",
    ENTER_YOUR_MOBILE: "Enter Mobile Number",
    ENTER_EMAILID: "Enter Email ID",
    ENTER_NAME: "Enter Name",
    ENTER_MOBILE: "Enter Mobile Number",
    CARE_EMAIL_ID_REQUIRED: "Email ID is required",
    EMAIL_NO_SPACES: 'Email should not contain spaces',
    EMAIL_LOWERCASE_START: 'Email should start with a lowercase letter',
    ERROR_IN_FETCHING: "Error in fetching table data:",
    EXPIRY: "Expiry:",
    EXPIRY_DATE:"Expiry Date ",
    SHOWING_TICKETS_FOR: "Showing Tickets For",
    STOP: "Stop",
    TICKET_ID_CAPS: "TICKET ID: #",
    OPEN_TICKET: "Open Ticket",
    WHATSAPP: "WhatsApp",
    LIKE_TO_CANCEL: "Would you like to cancel",
    LIKE_TO_CANCEL_SCHEDULE: "Would you like to Schedule/cancel",
    LIKE_TO_CANCEL_RESCHEDULE: "Would you like to reschedule/cancel",
    SELECT_DATE: "Select Date",
    SELECT_SLOT: "Select Slot",
    VIEW_PRESCRIPTION: "View Prescription",
    ERROR_MESSAGE_4: "Once Submitted, this appointment will be cancelled immediately",
    COMMENTS: "Comments",
    SELECT_ANY_REASON: "Select any reason",
    SNOOZ_FOR: "Snooze For",
    SELECT_ANY_ACTION: "Select any action",
    BASIC_INFORMATION_SMALL: "Basic information",
    VERIFY_EMAIL: "Verify Email",
    VERIFY_MOBILE: "Verify Mobile Number",
    SETUP_PROFILE: "Setup profile",
    ENTER_MAIL_MOBILE: "Enter your email id & mobile number",
    ENTER_OTP_MAIL: "Enter OTP sent to your Email ID",
    ENTER_OTP_MOBILE: "Enter the OTP sent to your mobile number",
    CREATE_PERSONALISED: "Create your personalised profile",
    SELECT_USER_TYPE: "Select the user type",
    CREATE_AN_ACCOUNT: "Create an Account",
    CUSTOM_DIAGNOSIS:"Clinical Diagnosis",
    EXIS_AILMENT:"Existing Ailments",
    COMORBITIES:"Comorbidities",
    MED_NAME:"Drug",
    MED_BRAND_NAME:"Brand",
    MED_BRAND_TYPE:"Type",
    MED_FORM:"Form",
    MED_DOSAGE:"Dosage",
    MED_ROUTE:"Route",
    MED_FREQUENCY:"Frequency",
    MED_DURATION:"Duration",
    MED_WHEN_TO_TAKE:"When to take",
    MED_ADJUVANT:"Adjuvant",
    MED_INSTRUCTION:"Instruction",
    MED_EDIT:"Edit",
    MED_DELETE:"Delete",
    ALLOPATHY_PLEASE_SELECT: "Please select either Allopathy or Ayurveda Prescription type",
    ALLOPATHY_UPDATE_MSG: "Update or Cancel the previous edit to proceed further",
    ALLOPATHY_CANNOT_SUBMIT: "Cannot submit empty Prescription!",
    ALLOPATHY_UPDATE_OR_CANCEL: "Update or Cancel the previous edit to proceed further!!",
    ALLOPATHY_DRUG_TYPE: "Drug Type",
    FROM_DIAGNOSIS_FORM: "From Diagnosis form",
    NO_PREVIOUS_DIAGNOSIS: "No previous Diagnosis.",
    REVISED: "Revised",
    ADD_OR_EDIT: "Add/Edit Diagnosis here...",
    FORM_HI_FORM: "From HI form",
    BRAND_NAME: "Brand Name",
    DRUG_NAME: "Drug Name",
    SELECT_ROUTE: "Select Route",
    ORAL: "Oral",
    EXTERNAL_MASSAGE: "External/local application/massage",
    HEAD_MASSAGE: "For Head Massage",
    SUBLINGUAL: "Sublingual",
    INTRAVENOUS: "Intravenous",
    INTRAMUSCULAR: "Intramuscular",
    SUBCUTANEOUS: "Subcutaneous",
    RECTAL: "Rectal",
    INTRANASAL: "Intranasal",
    INHALATIONAL: "Inhalational",
    TRANSDERMAL: "Transdermal",
    INTRATHECAL: "Intrathecal",
    ADJUVANT: "Adjuvant",
    MG: "mg",
    ML: "ml",
    DAYS: "Day(s)",
    WEEK_S: "Week(s)",
    MONTH_S: "Month(s)",
    YEAR_S: "Year(s)",
    TABLET_S: "Tablet(s)",
    FORM: "Form",
    POWDER: "Powder",
    TABLET: "Tablet",
    CAPSULE: "Capsule",
    LIQUID: "Liquid",
    CREAM: "Cream",
    DROPS: "Drops",
    INHALER: "Inhaler",
    MEDICATED_GHEE: "Medicated Ghee",
    JAM_PASTE: "Jam/Paste",
    MEDICATED_OIL: "Medicated oil",
    MEDICATED_TAILA: "Medicated Taila",
    INSTRUCTION: "Instruction",
    ADD: "Add",
    ADDED_PRESCRIPTION: "Added Prescriptions",
    WOULD_YOU_LIKE: "Would you like to select any pre-defined set of prescriptions",
    PLEASE_SELECT_ROUTE: "Please select route type!",
    YOUR_ADDED_PRESCRIPTION: "Your added prescriptions will appear here",
    CLEAR_ALL: "Clear All",
    INSTRUCTION_COLON: "Instruction:",
    SELF_ASSESSMENT_ENABLED: "Self Assessment enabled every",
    FIFTEEN_DAYS: "15 days",
    SWITCH_TAB: "Switch Tab",
    UNSAVED_CHANGES: "There are unsaved changes. Are you sure to switch Tab?",
    CONSULTATION_FOR_CURRENT_YEAR: "You have not taken any consultation for the current year.",
    CONSULTATION_FOR_PAST_YEAR: "You have not taken any consultation for the past years.",
    CANNOT_SUBMIT_EMPTY: "Cannot submit empty form!",
    CHALLENGES: "Challenges",
    EMOTION_ASSESS: "Depression/Anxiety",
    SENIOR_ADULT:"Senior Adult",
    EMOTIONAL: "Emotional",
    DIAGNOSIS_COGNITIVE: "Cognitive",
    BEHAVIOURAL: "Behavioural",
    PHYSICAL: "Physical",
    COMPETENCY: "Competency",
    TEST_FINDINGS: "Test Findings",
    FINDING_FOR_DSM: "Findings from DSM",
    IMPRESSION_DIAGNOSIS: "Impression / Diagnosis",
    CONTRIBUTING_MAINTAINING: "Contributing and Maintaining Factors",
    WELLNESS_GOAL: "Wellness Goal and Ayurvedic Approach to Diet",
    TO_BE_FAVOURED: "To be Favoured",
    TO_BE_AVOIDED: "To be Avoided",
    DIET_ADVISED: "Diet Advised",
    FAILED_TO_ADD_DESCRIPTION: "Failed to Add Description, Please try later",
    INSTRUCTION_GIVEN_BELOW: "Instructions given below will be displayed to care admin at the time of care team assignment.",
    FEEDBACK_PUBLISH:"Psychological Feedback Report for this consultation is published.",
    PSYCHIATRIC_PUBLISH:"Psychiatry Feedback Report for this consultation is published.",
    PRESCRIPTION_PUBLISH:"Prescription for this consultation is published.",
    PRESCRIPTION_PUBLISH_IN_PROGRESS:"Prescription publish is in progress for this consultation",
    PRESCRIPTION_WILL_BE_PUBLISHED:"Prescription publish is in progress will be published shortly.",
    INSTRUCTIONS: "Instructions",
    DOCTOR_REFERAL_ERR_MSG: "Please add Clinician name to refer!",
    SPECIALITY_NAME: "Speciality Name",
    SPECIALITY: "Speciality",
    SPECIALITY_DOCTOR: "Speciality Doctor",
    FREQUENCY_IN_WEEKS: "Frequency in Weeks",
    NEXT_APPOINTMENT_DATE: "Next Appointment Date:",
    NEXT_APPOINTMENT: "Your next Appointment will be on",
    PLEASE_SELECT_DATE: "Please select date!",
    APPOINTMENT_TIME: "Appointment Time:",
    YOUR_APPOINTMENT_TIME: "Your Appointment time will be at",
    PLEASE_SELECT_TIME: "Please select time!",
    SELECT_TIME: "Select Time",
    REACTION_TO_CRITICISM: "Reactions to criticism, provoking /stressful situation",
    REACTION_TO_STRESS: "Reactions to stress (Coping & Defense mechanisms)",
    AFFECT: "Affect",
    CASE_FORMULATION_1:"Case Formulation 1",
    CASE_FORMULATION_2:"Case Formulation 2",
    Add_Formulation_1:"Add Case Formulation 1",
    Add_Formulation_2:"Add Case Formulation 2",
    GEN_ASSESS:"General Assessment",
    DSM:"DSM",
    MSE:"MSE",
    PSY:"BPI",
    TPN:"TPN",
    PFACT:"P-FACT",
    DOTS:"DOTS",
    SOS:"SOS",
    CONCOG:"CONCOG",
    AI_FORM:"AI Smart Forms",
    CONPSYQ:"CONPSYQ",
    CONFAS:"CONFAS",
    ADD_COUPON:"Add Coupon",
    ADD_CONFAS:"Add CONFAS",
    ADD_CONCOG:"Add CONCOG",
    ADD_AIFORM:"Add AI Form",
    ADD_CONPSYG:"Add CONPSYQ",
    STRESS_MNG:"Stress Management",
    GERIATRIC:"Geriatric",
    CF1:"CF-1",
    CF2:"CF-2",
    FEED_RPT:"Feedback Report",
    DIAGNOSIS:"Diagnosis",
    C_NOTES:"Case Notes",
    ESSENTIAL_Q:"Documents Upload",
    CONFAS:"CONFAS",
    CONPSYG:"CONPSYQ",
    CONCOG:"CONCOG",
    ADD_ESS_Q:"Add Documents Upload",
    RX:"Rx",
    GCS:"GCS",
    T_PLAN:"T-PLAN",
    UPLOAD_FILE:"Upload File",
    DOCS:"DOCS",
    DIAG:"DIAG",
    CNOTES:"C-NOTES",
    YES_CANCEL: "Yes, Cancel",
    YES_RESCHEDULE: "Yes, Reschedule",
    NO_PRESCRIPTION_REQUIRED:"No Prescription required for this consultation.",
    PREVIEW_PRESCRIPTION: "Preview Prescription",
    PRIEW_MEDICAL_TEST:"Preview Medical Test List",
    REVISED_DIAGNOSIS: "Revised Diagnosis",
    COMORBIDITIES_HI_FORM: "Comorbidities HI form",
    COMORBIDITIES_FROM_FORM: "Comorbidities from Form",
    REVISED_COMORBIDITIES: "Revised Comorbidities",
    ADD_OR_EDIT_COMORBIDITIES: "Add/Edit comorbidities here...",
    ALLOPATHY: "Allopathy",
    AYURVEDA: "Ayurveda",
    INCLUDE_HERBAL: "Include Herbal",
    HERBAL: "Herbal",
    ADD_NEW_DRUG: "+Add new medicine to DB",
    SUMMARY: "Summary",
    PREDEFINED_MEDICINE: "Predefined medicine",
    CLINICIAN_COMMENTS: "Clinician's instructions/comments",
    SEARCH_BY_DIAGNOSIS: "Search by Diagnosis...",
    PERSONAL_GOALS : "Personal Challenges",
    ASSESSING_FLEXIBILITY : "Assessing Psychological Flexibility",
    FEEDBACK:"Feedback",
    PLAN_HISTORY:"Plan History",
    APPT_ACCEPTED_STS : "accepted",
    BRAND_DRUG: "Brand, Drug",
    PREVIEW_PUBLISH:"Preview & Publish",
    CHAT_CLOSED_MSG: "This chat is closed. If you wish to restart or continue, please close and open the chat window.",
    CHAT_CONNECT_FAILED_MSG: "Failed to connect chat. If you wish to restart or continue, please close and open the chat window.",
    CHAT_CLOSED_MSG_CA: "Oops! User has closed this chat session.",
    FEEDBACK_FORM: "Leave Your Feedback",
    CLINICAL_RATING: "Clinician Rating",
    CALL_RATING: "Call Rating",
    SUBMITTED: "Submitted",
    NOT_FILLED: "Not Filled",
    PUBLISHED: "Published",
    NOT_PUBLISHED: "Not Published",
    PRESCRIPTION_REPORT: "Prescription Report",
    P_FACT: "Protective Factors",
    DOCTOR_REFERRAL: "Doctor Referral",
    FINISH_CONSULTATION: "Finish Consultation",
    CONFIRM_STATUS: "Confirm Ticket Status",
    RESET_PASSWORD:"Reset Password",
    SET_PASSWORD:"Set password",
    RESETTING_PASSWORD:"Resetting Password...",
    FINISH_CONSULTATION_HEADING: "Do you want to finish this consultation?",
    FINISH_CONSULTATION_POINT_1: "Clicking on finish consultation ends the Video Consultation session and no one will be able to rejoin this room. If you want to end this Video Consultation session click on “End Session”.",
    FINISH_CONSULTATION_POINT_2: "If you plan to rejoin this session click on “Close page but don't End Session”. If client has not joined, click on client “Client No-Show”.",
    SCHEDULE_CALL_MSG: "You have chosen to resolve the ticket by Scheduling the call.",
    CANCEL_CALL_MSG: "You have chosen to resolve the ticket by Cancelling the call.",
    RESCHEDULE_CALL_MSG: "You have chosen to resolve the ticket by Rescheduling the call.",
    CLIENT_WILL_JOIN_MSG: "You have chosen to resolve the ticket by Client will join the call.",
    CANCEL_SESSION:"Client No-Show",
    DONT_END_SESSION:"Close page but don't End Session",
    END_SESSION:"End Session",
    END_CALL_POINT1: "Clicking on this button only ends the video call.",
    END_CALL_POINT2: "To end this video consultation session please click on Finish Consultation after filling up the required forms.",
    FOLLOW_UP: "Follow Up",
    SELECT_AGE: "Select your age category",
    BEFORE_SINGUP: "Confirm your age to access ",
    BELOW_18_YEARS: "Below 18 Years",
    ABOVE_18: "18 Years & Above",
    PREVIOUS_CONSULTATIONS_RATING:"Summary",
    CURRENT_CONSULTATIONS_RATING:"This Session",
    AGE_RESTRICTION: "Sorry, you are not eligible to create an account with",
    AGE_VERIFICATION: "Age Verification",
    UH_OH: "Uh-oh",
    DONT_HAVE_ACCESS: "Sorry, you don’t have access to create an account with ",
    NEED_HELP: "NEED HELP?",
    CONTACT_CARE_ADMIN: "Contact our Care admin ",
    SEND_EMAIL: "Send an email to our Care admin ",
    SUPPORT_NIYAMA: "care@ziloy.ae",
    CAREADMIN_NUMBER: "+971 80023",
    MODE_ERROR:"Please select the mode.",
    REASON_ERROR:"Please add a reason. ",
    ADD_ENCOUNTER:"Add Zero Enounter",
    COMM_MODE:"Mode",
    APPOINTMENT_PLACEHOLDER:"Select Appointment Date and Time",
    REASON:"Reason",
    SELECT_APPOINTMENT_PLACEHOLDER:"Select Date and Time",
    SELECT_MODE:"Select Mode",
    ENCOUNTER_REASON:"Please add reason...",
    AVAILED_ON: "Planned sessions comp. on",
    AVAILED: "Planned sessions comp. date: ",
    CONFRIM_PRESCRIPTION_TYPE:"Selected Medication type as",
    CONFRIM_PRESCRIPTION_TYPE_DESCRIPTION:"Medication type cannot be modified after saving a prescription.",
    VIEW_REPORT: "View Report",
    EXPORT: "Export",
    CASE_SUMMARY_REPORT: "Case Summary Report",
    THIS_REPORT_WILL_AVAILABLE_FOR_24_HOURS: "This report will availabe for 24 hours",
    CASE_SUMMARY_REPORT_IS_IN_PROGRESS: "Case Summary Report generation is currently in progress",
    PROCEED: "Proceed",
    PROCEEDING: "Proceeding",
    CHANGE_DATE_TIME_SLOT: "Change date & time slot",
    CHOOSE_YOUR_PREFERRED_TIME: "Choose your preferred time",
    CHOOSE_PREF_LANG:"Choose your preferred language for free assessment",
    CHOOSE_PREF_LANG_AND_START:"Choose your language and get started",
    CHOOSE_PREF_LANGUAGE:"Choose your preferred language",

    APPOINTMENT_MODAL_CONFORMATION_CONTENT: "Are you sure to proceed with the appointment on",
    SPEECH_TXT_ERR_MSG: "There seems to be a problem with audio",
    ASSESSMENT_HEADER: "Keep track of all of your mental health assessments",
    ASSESSMENT_DEPRESSION_HEADER: "Self Assessment for Depression & Anxiety",
    ASSESSMENT_STRESS_HEADER: "Self Assessment for Stress",
    ASSESSMENT_GERIATRIC_HEADER:"Self Assessment for Senior Adult",
    SUBSCRIPTION_HEADER: "Resilience Building & Sleep Optimisation Programme",
    MY_ORDERS_HEADER: "Keep track of all your orders here",
    YOUR_RESULTS: "Your Results",
    CARE_PLAN: "Care Plans For You",
    COMPLETED_ASSESSMENT: "Assessment Completed!",
    OVER_THE_LAST_TWO: "Over the last two weeks, how often have you been bothered by any of the following problems?",
    TEST_NAME:"Test Name",
    UPLOADED_BY:"Uploaded by",
    MED_TEST_NAME:"Test Name",
    MED_TEST_UPLOADED_BY:"Uploaded By",
    UPLOAD_BY_ERR_MESSAGE:"Please select uploaded by.",
    MED_TEST_NAME_ERR_MESSAGE:"Please add Test name.",
    CLINICAL_INSTRUCTION:"Clinical Instruction",
    SPEECH_TXT_ERR_MSG: "There seems to be a problem with audio",
    PUBLISH_SELECT:"Confirmation",
    PSYCHOTHERAPY_PSYCHOEDUCATION: "Psychotherapy psychoeducation:",
    CLINICIAN_INSTRUCTION:"Clinician's Instruction",
    CONFIRM_FOLLOW_UP:"Follow up  appointment booked, you cannot modify after saving.",
    COFIRM_NO_FOLLOW_UP:"No Follow up appointment required, you can still modify after saving.",
    SIGN_UP_TITLE: "Let's get your account set up",
    CREACT_ACCOUNT: "Create Account",
    SIGN_UP_TITLE_2:"Choose an option based on who requires care.",
    SIGN_UP_TITLE_3: "To make sure we get this right, we need to verify your email and mobile number.",
    LOG_IN_MAIL_DESC: "If you are using mobile, enter without country code",
    MOBILE_NUM_CODE: "Enter mobile number without country code",
    ENTER_OTP_CONTENT: "Enter the OTP sent to your email id",
    ENTER_MOBILE_CONTENT: "Enter the OTP sent to your mobile number",
    LOG_IN_CCODE_MAIL_DESC:"Please add country code (eg: +91) followed by mobile number",
    CLINICIAN_INSTRUCTION:"Clinician's Instruction",
    CLINICIAN_NOT_AVAILABLE:"Clinician not available!",
    SCHEDULE_NOT_AVAILABLE:"Scheduling not available!",
    ASSESSMENT_RESULT_HEADER: "Self Assessment for Depression & Anxiety",
    APPOINTMENT_HEADER: "Schedule and keep track of your upcoming appointments",
    APPOINTMENT_DETAIL_HEADER: "Know the details of your appointment",
    HEALTH_INFORMATION_HEADER: "Update your basic information and medical history ",
    DOCUMENT_UPLOAD: "Document Upload",
    DOCUMENTS_UPLOAD: "Documents Upload",
    DOCUMENT_UPLOAD_HEADER: "Upload and keep track of medical documents",
    DOCUMENT_UPLOAD_HEADER_2: "Upload the clinician requested document",
    DELETE_FILE:"Delete File",
    DELETE_FILE_DESC:"Are you sure you want to delete the uploaded document",
    DEPEDANT: "Dependant(s)",
    FILTER_BY: "Filter by:",
    SELECT_STATUS: "Select Status",
    OPEN: "Open",
    CLOSED: "Closed",
    APPLY_FILTERS: "Apply Filter",
    RESET_FILTERS: "Reset Filter",
    CREATE_COUPOUN:"Create Coupon",
    PLAN_NAME:"Plan Name",
    ADD_INSTRUCTION:"Add Instruction",
    YOUR_SELECTED_PLAN:"Your selected plan",
    EXCLUSIVE_PLAN:"An exclusive plan for you",
    PAYMENT_DETAILS:"Payment details",
    PAYMENT_DETAILS_DCAPS:"Payment Details",
    PAYABLE_AMOUNT:"Payable Amount",
    START_ASSESSMENT:"Let’s Start Answering",
    SYMPTOMPS:"The following questionnaire is used to determine whether you are experiencing symptoms of a mental health condition.",
    LESS_THAN_MINUTES:"It should take less than 2 minutes to complete.",
    EVERY_15_DAYS:"You can take this assessment every 15 days.",
    NEW_APPOINTMENT: "New Appointment",
    BOOK_SLOT: "Book your slot for video consultation",
    ARE_U_SURE: "Are you sure to proceed the appointment ",
    DELETE_RECORD:"Are you sure want to delete this record?",
    RESCHEDULE_MAIN_CONTENT: "On confirmation, a request to reschedule the appointment will be created. Our Care Admin will reach out to you shortly.",
    RESCHEDULE_SECOND_CONTENT: "Do you want to reschedule?",
    CANCEL_MAIN_CONTENT: "On confirmation, a request to cancel the appointment will be created.",
    CANCEL_SECOND_CONTENT: "Do you want to cancel?",
    SCHEDULE_NEW_APPOINTMENT: "Your new appointment will show here.",
    NO_UPCOMING_APPOINTMENTS: "No upcoming appointments!",
    PLEASE_SIGN_UP:"Please sign up to know your assessment result",
    KINDLY:"Kindly",
    LOGIN:"Login",
    OR:"or",
    SIGNUP:"Sign up",
        SIGNUP_CAPS:"SIGN UP",

    ASSESSMENT_RESULT:"to know your assessment result.",
    TAKE_NEW_ASSESS:"Take a new assessment to show here.",
    RESCHEDULE: "Reschedule",
    DELETE_ACCOUNT_MESSAGE: "Deleting the account will delete all the profiles under this account.",
    TAKE_EVAL_PLAN:"Take evaluation plan",
    UNLIKELY:"Unlikely",
    MED_LIKELIHOOD:"Medium likelihood",
    HIGH_LIKELIHOOD:"High likelihood",
    FOR_MYSELF: "For Myself",
    FOR_MYSELF_DESCRIPTION: "Create an individual account for you",
    FOR_DEPENDANT: "For Dependent",
    FOR_DEPENDANT_DESCRIPTION: "Create an account for anyone you care",
    IAM_GUARDIAN: "I’m a guardian",
    IAM_CREATING: "I’m creating an account for dependant",
    DISCARD_ASSES_DETAILS:"By continuing, your assessment details will be discarded.",
    OOPS:"Oops!",
    CHOOSE_ROLE:"Sign in to your account as",
    LAST_TAKEN_ON:"Last assessment taken on",
    NEXT_ASSESS:"Next assessment can be taken on or after",
    SORRY:"Sorry!!",
    CLIENT_CONFIRM_JOIN:"Client confirmed to join!",
    NO_ASSESS_ENABLE:"No assessment option enabled for your profile",
    BEGIN:"Begin",
    SENIOR_Alt:"Senior Adult",
    DEP_OR_ANX:"Depression/Anxiety",    
    SIGNING_UP: "Signing Up...",
    SIGN_UP_CAPS: "SIGN UP",
    NO_PAST_APPOINTMENT: "No past appointments!",
    COMPLETED_APPOINTMENTS: "You haven’t done any appointments yet.",
    CLINICIAN_TO_BE_ASSIGNED:"Clinician to be assigned",
    CLINICIAN_UNASSIGNED:"Clinician unassigned",
    PLUS_ONE_MORE: "+1 more",
    ATTACHMENTS: "Attachment(s)",
    CLICK: "CLICK HERE",
    DASHBOARD_MESSAGE: "Here’s what’s happening today.",
    WELCOME: "Welcome back,",
    WELCOME_UAE: "Welcome,",
    DOWNLOAD:"Download",
    NO_ORDERS:"No orders to show!",
    NO_PAYMENT:"You haven't done any payments yet.",
    SCORE_CARD_BOTTOM_TXT: "Your answer indicate you may currently be experiencing symptoms of",
    MINIMAL: "Minimal",
    RELATION_WITH_DEPENDENT: "Relationship with Dependant",
    FIRST_NAME: "First Name",
    SELF_ASSESSMENT_HEADER:"Self Assessment",
    CONFIRM_ACCOUNT:"Confirm Your Account ",
    CONFIRM_ACCOUNT_HEAD:"Confirm Account",
    CONFIRM_ACCOUNT_DESCP:"Help us set up your profile",
    YOUR_DETAILS:"Your Details",
    EDIT_DETAILS:"Edit Details",
    LAST_NAME: "Last Name",
    NEXT_STEP: "Next Step",
    ADD_PHOTO:"Add Photo",
    UPDATE_PHOTO:"Update Photo",
    PROFILE_DETAIL:"Profile Details",
    TREATMENT_PROTOCOL:"Ziloy Treatment Protocols",
    PROTOCOLS:"Ziloy treatment protocols",
    PLANS_OF_NIYAMA:"Integrative mental health plan for ",
    CARE_PLAN:"Your care plan",
    PLAN_DESCRIPTION:"Integrative mental health plan for ",
    ASSESMENT_SCORE_PAGE_DESCRIPTION : "You may want to pay close attention to how you’re feeling over the next two weeks and retake the questionnaire to see how you are doing. The results of your questionnaire are not a diagnosis of any mental health condition.",
    SET_GOALS:"Set your goals",
    AREA_OF_IMPROVEMENTS:"Areas of Improvement",
    TAKE_UR_ASSESS:"Take your assessment",
    SELECT_MIN_THREE:"Select a maximum of 3 options",
    ASSESMENT_SCORE_PAGE_DESCRIPTION : "You may want to pay close attention to how you’re feeling over the next two weeks and retake the questionnaire to see how you are doing. The results of your questionnaire are not a diagnosis of any mental health condition.",
    MEMCHECK_DESCRIPTION: "ZILOY’s MemCheck is designed to identify problems in higher brain functions. These complex brain abilities are frequently affected in disorders such as Dementia/Alzheimer’s disease, Stroke, Parkinson’s disease, and psychological conditions like depression, anxiety, stress, excessive alcohol intake, and certain drugs (prescription and recreational). Conditions like thyroid deficiency and Vitamin B12 deficiency may also cause such impairments. ",
    LEARN_MORE:"Learn more",
    MEMCHECK_NEXT_STEP_DESCRIPTION:"You may want to pay close attention to how you’re feeling over the next two weeks and retake the questionnaire to see how you are doing. The results of your questionnaire are not a diagnosis of any mental health condition.",
    GAD_SCORE: "Trail Making",
    PHQ_SCORE: "Picture Word Recall",
    PSYCHOSIS_SCORE: "Incomplete Letters",
    NCD_SCORE: "Word Picture Match",
    INSOMNIA_SCORE: "Insomnia",
    WOMENWELLNESS_SCORE: "Women's Wellness",


    HEALTH_RECORD:"Health Record",
    HEALTH_RECORD_DESCRIPTION:"Your medical history will help us provide a personalized holistic multi disciplinary care.",
    AGE_HEADING:"Treatment Programs by Age",
    STANDARD_OF_CARE: "Standard of care",
    STANDARD_OF_CARE_TITLE1: " advanced standard of care includes a dedicated Care Team, featuring psychiatrists, psychologists, yoga professionals, and nutritionists, all committed to providing comprehensive support for your mental health needs.",
    SELECT_ONE_TO_PROCEED:"Select one to proceed",
    STANDARD_OF_CARE_TITLE2:"*You can change these care plan option in Settings section.",
    CARE_TEAM_BE_ASSIGNED: "Care team to be assigned",
    B2B_CARE_TEAM_TITLE1:"We are curating your care team to guide you in your journey with Ziloy. Your Care Team will be comprised of {a},{b},{c}.",
    B2B_CARE_TEAM_TITLE2:"We will notify you via email and SMS once your care team is assembled. You can book an appointment with us once a care team is assigned.",
    BOOK_APPOINTMENT_WITH: "Book a session with ",
    CALL_US: "Call us",
    EXPERTS: "Experts",
    NEXT_AVAILABLE_ON: "Next available on ",
    YOUR_RESULTS: "Your Results",
    ASSESSMENT_RESULT_TEXT: "The assessment result shows how much you have experienced the below conditions",
    LEARN_ABOUT_SYMPTOMS: "Learn more about symptoms",
    LETS_GET_YOU_UP_AND_RUNNING: "Let’s get you up and running",
    LETS_DO_THIS: "Let’s do this",
    ABOUT_STRESS: "About Stress",
    RESULTS: "Results",
    NONE_TO_MILD_STRESS: "None to Mild Stress",
    MODERATE_STRESS: "Moderate Stress",
    SEVERE_STRESS:"Severe Stress",
    DONE: "Done",
    AGE_DESCRIPTION:"Choose an option to recommend the right type of guidance for who needs care.",
    EXC_PLAN:"An exclusinve plan from Ziloy for Star Health employee only",
    AN_EVIDENCE:"An evidence based stress reduction program comprising of stress reduction therapy from qualified psychologists and dietary recommendations from professional Nutritionists.",
    PLAN_DETAILS:"PLAN DETAILS",
    SESSIONS:"SESSIONS",
    NEED_BASIS:"*Sessions will be available for individuals on need basis.",
    STARTED_ON:"STARTED ON",
    VALID_TILL:"VALID TILL",
    RENEWAL_ITEMS:"Yearly renewal items",
    PERIOD:"PERIOD",
    RENEW_ACTUAL_PRICE:"(Will renew with actual price when term ends)",
    POINT_ONE:"Current invite is valid to the employees of Star Health Alliance Pvt. Ltd, Bangalore.",
    POINT_TWO:"Sessions mentioned for consultations, therapy, screening, nutrition and other related services like workshops will be free for the period and quantity mentioned. Any additional sessions, prescriptions and further consultations will be charges on actuals. ",
    POINT_THREE:"This care plan covers the individual of Star Health only and not the family members. ",
    POINT_FOUR:"Additional family members can be added to this account but will have a separate plan and billing cycle unique to the treatment plan as requested by the clinician. This will have to be borne by the sponsor (you).",
    POINT_FIVE:"If you want to cancel your account or have any related queries, do get in touch with your care navigator assigned to your account.",
    NOTES:"NOTES",
    ORG:"ORGANISATION",
    EMP_ID:"EMPLOYEE ID",
    EMAIL_STAR:"EMAIL",
    EMAIL_ID_START:"Email ID *",
    PHONE:"PHONE",
    DOB_STAR:"DATE OF BIRTH",
    NOT_YOUR_ACCOUNT:"NOT YOUR ACCOUNT",
    REPORT:"Report Misinformation",
    REPORT_ISSUE:"Report Misinformation",
    EXPLAIN:"Please mention your issue below",
    GET_PERSONALIZED:"Get your personalised treatment plan",
    EXPERT_INTEGRATIVE:"Expert integrative mental healthcare for anxiety, depression, stress, panic attacks, insomnia, chronic pain and more.",
    WELCOME_TO_NIYAMA:"Welcome to Ziloy Healthcare",
    THE_WORLDS_INTEGRATIVE:"The world’s first integrative digital mental health platform",
    THRILLED_TO_HAVE:"We're so thrilled to have you here. And that we can help guide you toward a healthier and happier life.",
    STANDARD_OF_CARE: "Standard of care",
    STANDARD_OF_CARE_TITLE1: " advanced standard of care includes a dedicated Care Team, featuring psychiatrists, psychologists, yoga professionals, and nutritionists, all committed to providing comprehensive support for your mental health needs.",
    SELECT_ONE_TO_PROCEED:"Select one to proceed",
    STANDARD_OF_CARE_TITLE2:"*You can change these care plan option in Settings section.",
    CARE_TEAM_BE_ASSIGNED: "Care team to be assigned",
    B2B_CARE_TEAM_TITLE1:"We are curating your care team to guide you in your journey with Ziloy. Your Care Team will be comprised of {a},{b},{c}.",
    B2B_CARE_TEAM_TITLE2:"We will notify you via email and SMS once your care team is assembled. You can book an appointment with us once a care team is assigned.",
    BOOK_APPOINTMENT_WITH: "Book a session with ",
    CALL_US: "Call us",
    YOUR_CARE_NAVIGATOR: "Your Care Navigator",
    EXPERTS: "Experts",
    NEXT_AVAILABLE_ON: "Next Available on ",
    LETS_GET_YOU_UP_AND_RUNNING: "Let’s get you up and running",
    LETS_DO_THIS: "Let’s do this",
    ABOUT: "About",
    RESULTS: "Results",
    NONE_TO_MILD_STRESS: "None to Mild Stress",
    MODERATE_STRESS: "Moderate Stress",
    SEVERE_STRESS:"Severe Stress",
    DONE: "Done",
    NONE: "None",
    NO_SYMPTOMS: "No Symptoms of Stress",
    MILD_RISK: "Mild Risk",
    MINIMAL_DEPRESSION: "Minimal Depression",
    MILD_DEPRESSION: "Mild Depression",
    MODERATE_DEPRESSION: "Moderate Depression",
    MODERATE_TO_SEVERE_DEPRESSION: "Moderate to Severe Depression",
    SEVERE_DEPRESSION: "Severe Depression",
    MINIMAL_ANXIETY: "Minimal Anxiety",
    MILD_ANXIETY: "Mild Anxiety",
    MODERATE_ANXIETY: "Moderate Anxiety",
    SEVER_ANXIETY: "Severe Anxiety",
    NIYAMA_PLAN_SESSION: "Let Ziloy handle my care plan sessions",
    CARE_PLAN_SESSION: "I want to choose my care plan sessions",
    ZILOY_WAY_TITLE: "ZILOY Way",
    A_LA_CARTE_TITLE: "À La Carte",
    CONTINUE_BOOK_APPOINTMENT: "Continue & Book Appointment",
    EXPERTISE : "Expertise",
    QUOTES:"Quotes",
    OTHER_COND:"Other Conditions",
    CARE_CONTACT: "+971 80023",
    CARE_EMAIL_ID: "care@ziloy.ae",
    CARE_EMAIL_ID_FOR_GUEST_USER: "care@ziloy.ae",
    COVER_YOUR_MENTAL_HEALTH:"Does your organisation cover your mental health with Ziloy?",    
    YOUR_PROFILE:"Your Profile",
    PROFILE_NOT_CREATED: "Profile not yet created!",
    CREATE_YOUR_PROFILE: "Create your profile",
    MEET_YOUR_CARE_TEAM: "Meet your dedicated care team",
    CARE_TEAM_HERE: "Your Care Team is here to support you for all your mental health needs.",
    CARE_TEAM_FOR_U: "Meet your dedicated care team",
    ASSESSMENT_SENSE:"An assessment to give you a sense of your risk for a common treatable condition stress.",
    REACH_ME_AT: "Reach me at",
    CARE_TEAM_WILL_BE_ASSIGNED_DESCRIPTION: "Your care team will be assigned once you have an active care plan.",
    TEAM_OF_EXPERTS: "Team of Experts",
    BECAUSE_CHOOSE_YOUR_SESSION: "Because you chose to plan your sessions, choose your sessions in any order",
    LANUGAGE_PREFERENCE:"Language Preference",
    TAKE_A_FREE_ASSESSMENT:"Take a Free Assessment",


    ADD_TO_CARE_TEAM: "Add to care team",
    BOOK_A_SESSEION :"Book a session",
    SEE_AVAILABLITY_AND_BOOK: "See Availability & Book Appointment",
    SEE_AVAILABLITY: "See Availability",
    WHY_ASSESSMENT:"Why do I need Assessment?",
    ADOLESCENT_LABEL:"Mental Health and Behavior assessment",
    SENIOR_ADULT_LABEL:"Mental Well-being and Cognitive Health assessment",
    ASSESSMENT_DESCRIPTION:"Consider taking a test to assess your mental health if you’ve noticed changes in how you feel or in your ability to function for the last for two weeks or more. If you’ve found yourself feeling extra tired, irritable, anxious, unfocused, or sad lately, and these symptoms are interfering with your ability to engage in your day-to-day life, these could be signs that you could benefit from mental health treatment.",
    NOTE:"Note",
    NOTE_DESCRIPTION:"You can take this assessment every 15 days.",
    CHOOSE_ONE_OR_MORE:"Choose one or more options",
    WHAT_BRINGS_YOU_HERE:"What brings you here?",
    EVALUATION_360: "360˚ Evaluation",
    EVALUATION_360_CONTENT_1: "Learn more about your symptoms and discuss them with our mental health professional. A 360˚ evaluation is a simple way for us to understand what you are going through at the moment.",
    EVALUATION_360_CONTENT_2: "Select the appropriate time to do a joint video consultation with our Care Clinician.",
    TAKE_EVALUATION_BY_AN_EXPERT: "Get Evaluated By An Expert",
    TAKE_EVALUATION_BY_AN_EXPERT_CONTENT_1: "Learn more about your symptoms and discuss them with our mental health professional. A 360˚ evaluation is a simple way for us to understand what you are going through at the moment.",
    TAKE_EVALUATION_BY_AN_EXPERT_CONTENT_2: "Take an Evaluation plan to start your journey with Ziloy.",
    SUBSCRIBE_NIYAMA_CARE: "Subscribe to Ziloy Care",
    SUBSCRIBE_NIYAMA_CARE_CONTENT_1: "You need an active Care Plan to proceed with booking your appointment.",
    APPOINTMENT_BOOKED_ALREADY: "Appointment Booked",
    APPOINTMENT_BOOKED_ALREADY_CONTENT_1: "You have already booked an appointment under your current plan.",
    APPOINTMENT_BOOKED_ALREADY_CONTENT_2: "",
    APPOINTMENT_SELECT_CLINICIAN_CONTENT: "Choose a preferred date and time slot once you have selected a Clinician from your Care Team.",
    SELECT_CLINICIAN:"Select Clinician",
    VIEW_CARE_TEAM:"View Care Team",
    TO_BE_ASSIGNED:"To be assigned",
    NO_ACTIVE_SUBSCRIPTION:"No active subscription",
    RECOVER_ACNT:"Recover Account",
    CONFIRM_ACTION:"Recover account",
    LOGIN_NOW:"Login Now",
    ACCOUNT_RECOVERED:"Recover account",
    ASSEMBLE_YOUR_CARE_TEAM:"Assemble your Care Team",
    CHOOSE_PREFERRED_CLINICIAN: "Choose your preferred clinician",
    SELECT_CLEINICIAN_FROM_EACH_SPECIALITY:"You can select one clinician from each speciality to be part of your Care Team",
    SELECTED_CLINICIAN: "Selected Clinician",
    CARE_ADMIN_DESC:"Your care team will be assigned after the first consultation with Ziloy clinician.",
    CARE_PLAN_DESC:"Take an Evaluation plan to proceed with booking an appointment.",
    CARE_TEAM_ASSIGN_SHORTLY: "Your care team will be assigned shortly!",
    CARE_TEAM_ASSIGN_NOTIFY: "You will be notified via mail and sms once the care team has been assigned.",
    CONTINUE_CHOOSE_CLINICIAN:"Continue & Choose Clinician",
    TAKE_ASSESSMENT_CAPS: "TAKE ASSESSMENT",
    PLAN_WARN_MAIN_TXT:"On continuing, you will proceed with the ZILOY way.",
    PLAN_WARN_MAIN_TXT_1:"Once selected it can’t be changed.",
    PLAN_WARN_SUB_TXT:"Do you want to continue with Ziloy way?",
    A_LA_CARTE_WARN_MAIN_TXT: "On continuing, you will proceed with the À-La-Carte way.",
    A_LA_CARTE_WARN_MAIN_TXT_1: "Once selected it can’t be changed.",
    A_LA_CARTE_WARN_SUB_TXT: "Do you want to continue with À-La-Carte way?",
    CHANGE_TIME_ZONE:"Change Time Zone",
    PREF_TIME_ZONE:"Preferred time zone",
    CUR_TIME_ZONE:"Current time zone",
    SWITCH_TIME_ZONE:"Do you want to switch your time zone?",
    LAUNCH_PRICE : "Launch Price",
    NEED_HELP_CAMEL_CASE: 'Need Help?',
    APPOINTMENT_DETAIL: "Appointment Detail",
    APPOINTMENT: "Appointment",

    TEEL_OWN_WORDS:"Tell us in your own words",
    SIGNIFICANT: "Significant",
   
   
   
    NO_SYMPTOMS_ONLY: "No Symptoms",

    // ASSESSMENT SCREEN

    ASSESSMENT:"Assessment",
    
   //DOCUMENT UPLOAD
   FILTERBY:"FILTER BY",
   CLINICIAN_NAME:"Clinician's Name",
   PATIENT_DESCRIPTION:"Patient's Description",
   REQUESTED_ON:"Requested On",
   UPLOADED_ON:"Uploaded On",
   YET_TO_UPLOAD:"Yet to Upload",

   //DOCUMENT UPLOAD MODAL
   DOCUMENT_NAME: "Document Name",
   UPLOAD_FILE_FORMAT_SIZE: "(File format: JPEG, PNG, PDF) | (Max file size: 25 MB)",
   UPLOAD_FILE_EXCEED: "File size is large, do not exceed 25MB",

   //APPOINTMENT
   THREE_OPTIONS:"Select a maximum of three reasons",
   PICK_DATE:"Pick a date",
   CHOOSE_TIME:"Choose the time",
   CONSULT_PHYSOLOGIST:"Consultant Clinical Psychologist",
   APPOINTMENT_CONFIRMATION:"Your appointment is Confirmed",

   //PLANS
   SIGNATURE_PLAN:"Signature Plans",
   SINGLE_SESSION:"Single Sessions",

   //Dashboard
   NO_TASK_SHOW: "No Tasks to show",
   INITIAL_ASSESSMENT: "Take the initial assessment to view your level of",
   SESSION: "session",
   OF: "of",
   SESSION_COMPLETED: "sessions completed",
   
   //Guest screens
   IAM_NEW_HERE : "I'm new here",
    HAVE_ALREADY_ACCOUNT : "I already have an account",
    GET_STARTED : "Get Started",
    CRITICAL_SITUATION : "If you are in a life threatening situation",
    DONT_USE_APP : "don't use this app.",
    IMMEDIATE_HELP : "To get immediate help",
    IAM_COVERED : "Yes, I’m covered",
    IAM_ON_OWN : "No, I’m on my own",
    GUARDIAN_DETAIL : "Guardian’s Details",
    ENTER_GUARDIAN_DETAIL : "Enter the details of guardian",
    NO_ACTIVE_SUBSCRIPTION: "No active subscription",    
    YOUR_RESULT: "Your Result",
    LEARN_ABOUT_SYMPTOMS: "Learn more about symptoms",
    YOUR_CARE_NAVIGATOR: "Your Care Navigator",
    ASSESMENT_SCORE_PAGE_DESCRIPTION : "You may want to pay close attention to how you’re feeling over the next two weeks and retake the questionnaire to see how you are doing. The results of your questionnaire are not a diagnosis of any mental health condition.",
    CHECKBOXES_WHATSAPP: " I agree to have my notifications sent via WhatsApp.",
    BY_SUBMITTING: "By submitting,",
    YOU_AGREE_TO : "you agree to",
    PLATFORM: "Ziloy platform",
    ENTER_MOBILE_VALID : "Please enter a valid mobile number",
    OR_TEXT : "or text ",
    TEXT : "Text",
    CONTACT_CARE_NAVIGATOR:"Contact Care Navigator at ",
    WRITE_TO_US:"or write to us on",
    REGISTERING_NIYAMA:" By registering with us, ",
    BEHALF_DEPENDENT:"on behalf of Dependant, ",
    AGREE_WATSAPP:" I agree to have my notifications sent via WhatsApp.",
    SET_PASSWORDSTAR: "Set Password *",
    PASSWORD_CONDITIONS: "Password should satisfy below conditions.",
    PASSWORD_CONDITIONS1: "No spaces allowed",
    PASSWORD_CONDITIONS2: "Minimum 8 characters",
    PASSWORD_CONDITIONS3: "Maximum 32 characters",
    PASSWORD_CONDITIONS4: "Contain atleast one number",
    PASSWORD_CONDITIONS5: "Contain atleast one lowercase letter",
    PASSWORD_CONDITIONS6: "Contain atleast one uppercase letter",
    PASSWORD_CONDITIONS7: "Contain atleast one symbol +!@#$%^&*_",
    CONFIRM_PASSWORDSTAR: "Confirm Password *",
    INVALID_FORMAT: "Invalid file format",
    FIRST_NAME_START:"First Name *",
    DOB_STAR:"Date Of Birth *",
    GENDER_STAR:"Gender *",
    RELATION_WITH_DEP_STAR:"Relationship With Dependent *",
    DEPENDENT_PROFILES:"Dependent Profiles",
    PLAN_INCLUDES_WITHOUT_COLON: "Plan includes",
    LANGUAGE_CONFIRMATION:"Do you want to proceed in English?",
    DEPENDENT_DESCRIPTION:"Your added dependents will appear here.",
    DEPENDENT_DESCRIPTION_1:"Your can add upto 5 dependent profiles",
    ACCOUNT_PROFILE_FOOTER:"If you are in a life threatening situation - don't use this app.",
    IN_CASE_OF: "In case of emergency, please contact Care Admin:",
    CHECK_AVAILABILITY: "Check Availability",
    NO_CHANGES_MADE:"No changes made",
    PLEASE_FILL_THE_DOCUMENT_NAME:"Please fill the Document Name",
    PLEASE_UPLOAD_DOCUMENT:"Please upload document",
    PLEASE_CHANGE_THE_FILE:"Please change the file",
    INVALID_FILE_FORMAT:"Invalid file format",
    TYPE_HERE_DOT:"Type here...",
    ENTER_PASSWORD:"Enter password",
    OTP_VERIFICATION: "OTP Verification",
    OTP_MESSAGE_PASSWORD: "OTP verified. Enter a new password",
    OTP_MESSAGE_EMAIL: "Enter the otp sent to your Email Id:",
    OTP_MESSAGE_MOBILE: "Enter the otp sent to your Email Id:",
    NEXT_CAP:"NEXT",
    PICK_A_DATE:"Pick a date",
    CHOOSE_THE_TIME:"Choose the time",
    DEPRESSION_SCORE: "Depression Score",
    ANXIETY_SCORE: "Anxiety Score",
    STRESS_SCORE:"Stress Score",
    KNOW_MORE: "Know more",
    KNOW_LESS: "Know less",

    PLEASE_WAIT: "Please wait...",
    YES_CONTINUE_WITH: "Yes, continue with",
    NO_IM_OKAY_WITH: "No, I’m okay with",
    LANGUAGE_PROFILE_SELECTION: "Language based on your profile settings",
    LANGUAGE_CURRENT_SELECTION: "Language based on your current selection",
    LOOKS_DELECTED_YOUR_ACCOUNT:"Looks like you have deleted your account recently. Your account cannot be recovered after",
    TOAST_OTP_SENT_MSG:"OTP sent to your registered email id/mobile number, please check your inbox/spam box",
    TOAST_USER_NOT_ALLOWED_MSG:"User was not allowed to Login",
    TOAST_USER_NOT_REGISTER_MSG:"User is not registered with us.",
    MORE: "more",
    SESSIONS_LOWER: "sessions",
    PSYCHIATRY_REPORT:"Psychiatry Feedback Report",
    CHAT: "Chat",
    VIEW_HEALTH_INFOMATION: "View Health Information",
    REJOIN_CONSULTATION: "Rejoin Consultation",
    VIDEO_CONSULTATION_ENDED_WITH: "Video Consultation has ended with",
    WRITE_MESSAGE: "Write a message",
    TOAST_INVALID_SUPPORT_FILE:"Invalid file type. Supports only PNG or JPEG or PDF file.",
    CLOSE_CALL_DOCTOR: " Do you want to close this video call?",
    CLOSE_CALL_PATIENT: "Do you want to end this consultation?",
    SELECT_ONE: "Select one",
    YOUR_PAY: "You pay AED ",  
    FAVOURED: "Favored",
    AVOIDED: "Avoided",
    ADVISED: "Advised",
    WELLNESS_GOAL_AND_AYURVEDIC_DIET: "Wellness Goal and Ayurvedic Approach to Diet",
    MORNING: "Morning",
    AFTERNOON: "Afternoon",
    EVENING: "Evening",
    NIGHT: "Night",
    AYURVEDIC: "Ayurvedic",
    MEDICAL_TEST: "Medical Test",
    DIET_PLANS: "Diet plans",
    LIMITATIONS: "Limitations",
    YOGA: "Yoga Routine",  
    ASK_ME_QUESTION: "Hello, ask me a question or select one below.",
    CAN_HELP: "How can we help you?",
    ALREADY_ACTIVE_SESSION: "Looks like you already have an active chat session.",
    NEW_CHAT: "Would you like to open a new chat?",
    ASK_QUESTION: "Ask Question",
    CLOSE_CHAT: "Are you sure to close this chat?",
    LIVE_CHAT: "Live chat",
    TALK_TO_CUSTOMER: "Talk to our customer care",
    CAREADMIN: "Care Admin",
    IM: "I'm",
    VALUABLE_FEEDBACK: "Your valuable rating is important to us",
    CARE_NAVIGATOR: "Care Navigator",
    IM_SONIA: "I'm Sonia",
    TELL_US_RATE_SERVICE: "Tell us how you rate our service",
    ADD_COMMENTS: "Add your comments..",
    CHAT_AVAILABLE_MSG1:"Chat available between 10AM to 6PM(IST). Please reach out to our Care admin at",
    CHAT_AVAILABLE_MSG2: "or reach mail at",
    CHAT_SESSIONS:"This chat session has expired. Please open a new chat session",
    CHAT_UNABLE_TO_CONNECT1: "We are unable to connect you with our care admin on",
    CHAT_UNABLE_TO_CONNECT2: "Live Chat. Please reach out to our Care admin at",
    CHAT_UNABLE_TO_CONNECT3: "or reach mail at",
    PLEASE_WAIT_CAREADMIN: " Please wait for the Care Admin to join.",
    PLEASE_WAIT_CAREADMIN_CONNECT: "Please wait while we connect you to the Care Admin...",
    HOW_CAN_WE_HELP: "! How can we help you today?",
    THERE: "there",
    CHOOSE_A_CARE_PLAN_TO_PROCEED_WITH_YOUR_APPOINTMENT_BOOKING:"Choose a care plan to proceed with your appointment booking.",
    PARLLEL_CONFIRMATION_TEXT_CONTENT_1:"The session benefits of this plan will be added to your already existing active care plan.",
    SELECTED_PLAN:"Selected Plan",
    TYPE_NEW_MESSAGE: "Type a new message",
    YOUR_ARE_CONNECTED: "You are connected with",
    SELECT_RELEVANT_OPTION: "Please select the relevant option you are looking for",
    VIDEO_CONSULTATION_JOINED: "Video consultation can be joined only 5 minutes before schedule, and time remaining is ",
    APPLIED_COUPON: "Applied Coupon ",
    SUCCESSFULLY_CAPS:" Successfully!",
    DETAILED_REPORT:"Detailed Report",
    WHAT_YOU_WILL_GAIN:"What You Will Gain",
    MENTAL_WEALTH_JOURNEY_GUIDANCE:"Score insights & Expert recommendations to start your journey and build mental wealth.",
    GRAB_YOUR_COMPLETE_REPORT:"Grab your complete report",
    YOU_HAVE_UNLOCKED:"You Have Unlocked",
    DOWNLOAD_REPORT:"Download Report",
    YOUR_SELECTED_REPORT:"Your selected report",
    YOUR_REPORT_PAYMENT_SUMMARY:"Your report & payment summary",
    REPORT_INCLUDES:"Report Includes :",
    PAYMENT_SUCCESSFUL:"Payment Successful!",
    ORDER_NO:"Order No",
    REPORT_CREATED_ON:"Report created on",
    DETAILED_SELF_ASSESSMENT_REPORT:"Detailed Self-Assessment Report",
    SEE_MY_SCORE_CAPS:"See Your Score",
    REVIEW_YOUR_OUTCOME:"Review your outcome and next step",
    ACTIVE_PLANS:"Active Plan(s)",
    EVERY_15_DAYS_TAKE_ASSESSMENT:"You can take this assessments every 15 days, from your last assessed date.",
    VALID_UPTO_WITHOUT_COLON:"Valid till",
    CREATE_PROFILE:"Create Profile",
    EMERGENCY_CONTACT:"In case of emergency, please contact Care Admin",
    SUPPORT_24_7:"24/7 Support",
    PROCEED_TO_DASHBOARD:"Proceed To Dashboard",
    NO_OF_ITEMS:"page",
    PLEASE_WAIT_FOR:"Please wait for",
    TO_JOIN:"to join.....",
    FOUR_MORE:"+4 more",
    VIEW_MORE_COUNT:"+{{count}} more",
    SHOW_LESS:"Show less",
    ACTIVE_CARE_PLANS:"Active Plans",
    ADD:"Add ",
    UPLOAD_ERROR:"Upload Error",
    START_BUILDING_MENTAL_WEALTH:"Start Building Mental Wealth",
    PLEASE_VERIFY_YOUR_EMAIL_ID_AND_MOBILE_NUMBER:"Please verify your email id and mobile number",
    PLEASE_PROVIDE_YOUR_BASIC_DETAILS:"Please provide your basic details.",
    PLEASE_PROVIDE_YOUR_BASIC_DETAILS_AND_GUARDIAN_CONSENT:"Please provide few basic details.",
    PLEASE_SIGN_UP_TO_KNOW_ASSESSMENT_RESULT:"Please sign up to know your assessment result",
    PLEASE_LOGIN_TO_KNOW_ASSESSMENT_RESULT:"Please login to know your assessment result",
    COMING_SOON:"Coming soon",
    VALIDATION_EMAIL_MESSAGE:"Please enter a valid email id",
    VALIDATION_MOBILE_MESSAGE:"Please enter valid mobile no. with country code (eg:+91)",
    CONTINUE_TO_SIGNUP:"Continue to signup",
    LIMITATION_ADD_NEW_MEMBER:"You’ve reached the limit for adding new members. Please contact our Care Navigator ",
    HAVE_ANY_QUESTIONS:" if you have any questions.",
    LEGAL:"Legal",
    TERMS_AND_CONDITION_FULL:"Terms & Conditions",
    PRIVACY_POLICY_WITHOUT_DOT:"Privacy Policy",
    SEE_ALL_COUPONS:"See all coupons",
    REPORTS:"Reports",
    ONE_REPORT:"Report",
    ON_DEMAND:"On demand",
    LIVE_COUPON:"Live Coupon",
    EMPTY_DOC_TEXT_1: "No medical documents uploaded!",
    EMPTY_DOC_TEXT_2: "Your uploaded documents will appear here.",
    VIEW_CARE_PLANS:"View Care Plans",
    SUBSCRIBED:"Subscribed",    
    AGE_LABLE:"For people aged ",
    RECOMMENDED_TAG:" (Recommended)",
    EDIT_PROFILE_PICTURE:"Edit Profile Photo",
    ADD_YOUR_PROFILE_PICTURE:"Add your profile picture",
    CHANGE:"Change",
    REMOVE:"Remove",
    OK_PROCEED:"Ok, proceed",
    REQ_MED_TEST:"Requested Medical Tests",
    GENERAL:"General",
    FREQUCENCYY:"Frequency: ",
    ASANAS:"Asanas",
    MEDICAL_TEST_REPORT:"Medical Test Report",
    YOGA_REPORT:"Yoga Report",
    DIET_REPORT:"Diet Report",
    CURRENT_TIME_ZONE: "Your current timezone is ",
    SAVE_PROFILE_SETTING:"Click save to change in profile settings",
    CURRENT_LANG: "Your current language is ",
    COPYRIGHT_2025_ZILOY:"2025 QuantumNexis L.L.C-FZ",
    DOWNLOAD_MEDICAL_TEST:"Download Medical Test",
    SAVE_AND_PREVIEW :"Save and Preview",
    PREVIEW_GENERAL_CASE_SHEET:"Preview General case sheet",
    GENERAL_CASESHEET_REPORT:"General Case Sheet Report",
    CARE_PATHWAYS:"Care Pathways",
    
    
}
